import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import stringify from '../utils/stableStringify';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import { unpack, pack } from 'msgpackr';
import format from 'string-format';
import { Form, EmptyItem, SimpleItem, ButtonItem, ButtonOptions } from 'devextreme-react/form';

import Calculator from '../utils/calculator';
import AntCondition from '../utils/AntCondition';
import AntLocalStorage from '../utils/AntLocalStorage';
import AntTime from '../utils/AntTime';
import AntConfig from '../utils/AntConfig';
import AntLocalization from '../utils/AntLocalization';
import { ValidationGroup } from 'devextreme-react/validation-group';
import { Validator } from 'devextreme-react/validator';
import { Template } from 'devextreme-react/core/template';
import { TextBox, CheckBox, SelectBox, TextArea, NumberBox, DateBox } from 'devextreme-react';

import { Button as TextBoxButton } from 'devextreme-react/text-box';
import ValidationEngine from 'devextreme/ui/validation_engine';

import AntFilterBuilder from './AntFilterBuilder';
import AntSelectBox from './AntSelectBox';
import AntTagBox from './AntTagBox';
import AntDropDownGrid from './AntDropDownGrid';
import AntDropDownTree from './AntDropDownTree';
import AntRichEditor from './AntRichEditor';
import AntAttachmentList from './AntAttachmentList';
import AntMonthBox from './AntMonthBox';
import AntYearBox from './AntYearBox';
import AntStepperBox from './AntStepperBox';
import AntImageUrl from './AntImageUrl';
import AntImageUrlList from './AntImageUrlList';
import AntAddress from '../utils/AntAddress';
import AntAddressField from './v2/AntAddressField';
import AntCategory from '../utils/AntCategory';
import AntAPI from '../utils/AntAPI';

import { AntGlobal, AntSession } from '../utils/AntContext';
// ─── Phone mask lookup by currency → country ────────────────────
var PHONE_MASKS = {
    VND: { mask: 'X000 000 000', rules: { X: /[02-9]/ } },
    THB: { mask: '000 000 0000', rules: {} },
    SGD: { mask: '0000 0000', rules: {} },
    MYR: { mask: '000 000 0000', rules: {} },
    IDR: { mask: '0000 0000 0000', rules: {} },
    PHP: { mask: '0000 000 0000', rules: {} },
    JPY: { mask: '000 0000 0000', rules: {} },
    KRW: { mask: '000 0000 0000', rules: {} },
    CNY: { mask: '000 0000 0000', rules: {} },
    INR: { mask: '00000 00000', rules: {} },
    USD: { mask: '(000) 000-0000', rules: {} },
    AUD: { mask: '0000 000 000', rules: {} },
    GBP: { mask: '00000 000000', rules: {} }
};
var DEFAULT_PHONE_MASK = { mask: '0000000000000', rules: {} };

function getPhoneMask() {
    try {
        var currency = AntLocalStorage.getSetting('Sys_BaseCurrency');
        return PHONE_MASKS[currency] || DEFAULT_PHONE_MASK;
    } catch (e) {
        return DEFAULT_PHONE_MASK;
    }
}

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const tableName = props.table ? props.table : props.API ? props.API.entityName : '';

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    // Nhãn + nước địa chỉ theo NGÔN NGỮ BUSINESS (đồng bộ với toàn app qua AntLocalization), KHÔNG
    // theo getSetting (đọc user_settings trước → user cài tiếng Anh riêng làm nhãn địa chỉ lệch tiếng Anh).
    const addrCountry = AntLocalStorage.getBusinessSetting('Sys_BaseCountry') || 'VN';
    const addrLocale = AntLocalStorage.getBusinessSetting('Sys_BaseLanguage') || 'vi';
    const [addrLoadTick, setAddrLoadTick] = useState(0);
    const AddressData = useMemo(() => new AntAddress(addrCountry, addrLocale), [addrCountry, addrLocale, addrLoadTick]);
    useEffect(() => {
        AntAddress.ensure(addrCountry, props.API).then(() => setAddrLoadTick((n) => n + 1));
    }, [addrCountry]);
    const CategoryData = useMemo(() => new AntCategory(appGlobal.appAssets.data.categoryData), []);
    const [shouldRender, setShouldRender] = useState(1);
    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const [formData, setFormData] = useState(props.formData ? props.formData : null);
    const [formItems, setFormItems] = useState([]);
    const formDisplayItemRefs = useMemo(() => props.items.map((i) => React.createRef()), []);

    const oldData = useRef({});

    const formLookups = useRef([]);

    const form = useRef();
    const validateGroup = useRef();
    const actionStatus = useRef();

    const formColCount = useMemo(() => {
        let value = AntCondition.getValue(formData, props.colCount);
        if (value === undefined) value = props.colCount ? props.colCount : props.colCountDefault ? props.colCountDefault : 1;
        return value;
    }, [formData]);

    const initRawFlatItems = useCallback((items, parent, parentIndex) => {
        var ar = [];
        if (items instanceof Array) {
            items.forEach((e, i) => {
                if (e.items instanceof Array) ar.push(...initRawFlatItems(e.items, e, i));
                else {
                    if (typeof e === 'object') {
                        if (e.itemType !== 'empty' && e.itemType !== 'group')
                            ar.push({
                                ...e,
                                groupIndex: parent && parentIndex !== undefined ? parentIndex : undefined,
                                groupName: parent && parent.name ? parent.name : undefined,
                                groupLabel: parent && parent.label ? parent.label : undefined
                            });
                    } else if (typeof e === 'string')
                        ar.push({
                            dataField: e,
                            groupIndex: parent && parentIndex !== undefined ? parentIndex : undefined,
                            groupName: parent && parent.name ? parent.name : undefined,
                            groupLabel: parent && parent.label ? parent.label : undefined
                        });
                }
            });
        }
        return ar;
    }, []);

    const rawFlatItems = useMemo(() => initRawFlatItems(props.items), [props.items]);

    const isDisableField = useCallback(
        (item) => {
            let editorType = item.editorType;

            if (editorType && (typeof editorType === 'object' || editorType instanceof Array))
                editorType = AntCondition.getValue(formData, editorType);

            if (editorType === 'antFormLink') return false;

            var obj = rawFlatItems.find((e) => e.dataField === item.dataField || (item.name && e.name === item.name));
            if (obj) {
                if (obj.disable === true || obj.disabled === true) return true;
                if (obj.disable === false || obj.disabled === false) return false;

                if (obj.editable === true || obj.editabled === true) return false;
                if (obj.editable === false || obj.editabled === false) return true;
            }

            if (item.dataField === 'id' && editorType === 'antDropDownGrid') return false;
            if (item.dataField === 'code' && editorType === 'antDropDownGrid') return false;

            if (!obj || obj.disable === undefined || !obj.disable.byPassCheckServer) {
                if (props.type === 'Update') {
                    if (
                        formData &&
                        formData.edit &&
                        formData.edit.always_editable_fields instanceof Array &&
                        formData.edit.always_editable_fields.includes(item.dataField)
                    )
                        return false;
                }
                if (props.type === 'Create') {
                    if (
                        formData &&
                        formData.create &&
                        formData.create.always_editable_fields instanceof Array &&
                        formData.create.always_editable_fields.includes(item.dataField)
                    )
                        return false;
                }
            }

            var disabled =
                props.disabled === true ||
                !formData ||
                !item ||
                ((!obj || obj.disable === undefined || !obj.disable.byPassCheckServer) &&
                    ((props.type === 'Update' &&
                        (!formData.id ||
                            !formData.edit ||
                            !formData.edit.isEditable ||
                            (formData.edit.editable_fields &&
                                formData.edit.editable_fields instanceof Array &&
                                formData.edit.editable_fields.indexOf(item.dataField) < 0 &&
                                !formData.edit.editable_fields.find((f) => typeof f === 'object' && f !== null && f.field === item.dataField)))) ||
                        (props.type === 'Create' &&
                            formData.create &&
                            formData.create.disable_fields &&
                            formData.create.disable_fields instanceof Array &&
                            formData.create.disable_fields.indexOf(item.dataField) > -1 &&
                            !formData.create.disable_fields.find((f) => typeof f === 'object' && f !== null && f.field === item.dataField))));

            if (disabled) return true;

            if (rawFlatItems instanceof Array) {
                var obj = rawFlatItems.find((e) => e.dataField === item.dataField || (item.name && e.name === item.name));
                if (obj) {
                    if (obj.disable === true || obj.disabled === true) return true;
                    if (obj.disable === false || obj.disabled === false) return false;

                    if (obj.editable === true || obj.editabled === true) return false;
                    if (obj.editable === false || obj.editabled === false) return true;

                    if (typeof obj.disable === 'object' && obj.disable !== null) {
                        if (obj.disable.type === 'self') {
                            if (obj.disable.self) {
                                var selfType = obj.disable.self.type;
                                var selfValue = formData[item.dataField];
                                var values = obj.disable.self.values;
                                var value = obj.disable.self.value;

                                if (selfType === 'diff') {
                                    return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                                } else {
                                    return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                                }
                            }
                        } else return AntCondition.isDisable(formData, obj);
                    }

                    if (typeof obj.editable === 'object' && obj.editable !== null) {
                        if (obj.editable.type === 'self') {
                            if (obj.editable.self) {
                                var selfType = obj.editable.self.type;
                                var selfValue = formData[item.dataField];
                                var values = obj.editable.self.values;
                                var value = obj.editable.self.value;

                                if (selfType === 'diff') {
                                    return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                                } else {
                                    return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                                }
                            }
                        } else return !AntCondition.isEditable(formData, obj);
                    }
                }
            }

            if (config) {
                var obj = config.getCnfField(item.cnfField ? item.cnfField : item.dataField);

                if (!obj) return false;

                if (obj.disable === true || obj.disabled === true) return true;
                if (obj.disable === false || obj.disabled === false) return false;

                if (obj.editable === true || obj.editabled === true) return false;
                if (obj.editable === false || obj.editabled === false) return true;

                if (typeof obj.disable === 'object' && obj.disable !== null) {
                    if (obj.disable.type === 'self') {
                        if (obj.disable.self) {
                            var selfType = obj.disable.self.type;
                            var selfValue = formData[item.dataField];
                            var values = obj.disable.self.values;
                            var value = obj.disable.self.value;

                            if (selfType === 'diff') {
                                return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                            } else {
                                return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                            }
                        }
                    } else return AntCondition.isDisable(formData, obj);
                }

                if (typeof obj.editable === 'object' && obj.editable !== null) {
                    if (obj.editable.type === 'self') {
                        if (obj.editable.self) {
                            var selfType = obj.editable.self.type;
                            var selfValue = formData[item.dataField];
                            var values = obj.editable.self.values;
                            var value = obj.editable.self.value;

                            if (selfType === 'diff') {
                                return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                            } else {
                                return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                            }
                        }
                    } else return !AntCondition.isEditable(formData, obj);
                }
            }

            return false;
        },
        [rawFlatItems, formData, props.type, props.disabled]
    );

    const isVisibleField = useCallback(
        (item) => {
            if (props.type === 'Update' && (!formData || Object.keys(formData).length <= 0)) return false;

            // Địa chỉ đa quốc gia: ẩn HẲN ô cấp vượt số cấp của nước (vd Việt Nam 2 cấp → ẩn ô cấp 3),
            // không chỉ bỏ phần nhập. Envelope chưa nạp xong thì tạm ẩn cấp ≥2 (tránh ô rỗng còn nhãn).
            var _admLvl = item && item.dataField ? AntAddress.admLevelFromField(item.dataField) : 0;
            if (_admLvl >= 2 && (!AddressData.isLoaded() || AddressData.getLevelCount() < _admLvl)) return false;

            if (item && item.visible === true) return true;

            var visible = AntCondition.isVisible(formData, item);
            if (visible === false) return false;

            var rawItem;
            if (rawFlatItems instanceof Array)
                rawItem = rawFlatItems.find((e) => e.dataField === item.dataField || (item.name && e.name === item.name));
            if (!rawItem) rawItem = item;

            if (rawItem.dataField && rawItem.byPassConfigVisible) return visible;

            if (item.itemType === 'group') {
                var gLabel = AntCondition.getValue(formData, item.label);
                gLabel = AntLocalization.translateText(gLabel);

                visible = false;
                if (rawFlatItems instanceof Array) {
                    var childVisibleQty = rawFlatItems
                        .filter((e) => {
                            if (e.item_type === 'group') return false;
                            var eName = e.groupName;
                            var eLabel = AntCondition.getValue(formData, e.groupLabel);
                            eLabel = AntLocalization.translateText(eLabel);
                            return item.name ? eName === item.name : eLabel === gLabel;
                        })
                        .map((e) => {
                            return isVisibleField(e);
                        })
                        .filter((e) => Boolean(e)).length;
                    visible = childVisibleQty > 0;
                }
                return visible;
            }

            if (item.itemType === 'button') return true;

            if (visible && rawItem.visibleDepends instanceof Array) {
                for (let i = 0; i < rawItem.visibleDepends.length; i++) {
                    const d = rawItem.visibleDepends[i];
                    if (visible && d.dataField) {
                        var secondItem = rawFlatItems.find((e) => d.dataField === e.dataField);
                        if (secondItem) {
                            if (d.visible !== undefined) {
                                var v2 = isVisibleField(secondItem) === d.visible;
                                visible = visible && v2;
                            }
                            if (d.editable !== undefined) {
                                var v2 = !isDisableField(secondItem) === d.editable;
                                visible = visible && v2;
                            }
                        }
                    }
                }
            }

            if (visible && rawItem.dataField) {
                var cnfItem = config.getCnfField(rawItem.cnfField ? rawItem.cnfField : rawItem.dataField);
                if (cnfItem && cnfItem.visibleDepends instanceof Array) {
                    for (let i = 0; i < cnfItem.visibleDepends.length; i++) {
                        const d = cnfItem.visibleDepends[i];
                        if (visible && d.dataField) {
                            var secondItem = rawFlatItems.find((e) => d.dataField === e.dataField);
                            if (secondItem) {
                                if (d.visible !== undefined) {
                                    var v2 = isVisibleField(secondItem) === d.visible;
                                    visible = visible && v2;
                                }
                                if (d.editable !== undefined) {
                                    var v2 = !isDisableField(secondItem) === d.editable;
                                    visible = visible && v2;
                                }
                            }
                        }
                    }
                }
            }

            if (visible && rawItem.dataField) {
                var cnfItem = config.getCnfField(rawItem.cnfField ? rawItem.cnfField : rawItem.dataField);
                if (cnfItem) {
                    visible = AntCondition.isVisible(formData, cnfItem);
                    if (visible && cnfItem.visibleOnMain) {
                        let vObj = cnfItem.visibleOnMain;
                        if (cnfItem.visibleOnMain instanceof Array) {
                            vObj = cnfItem.visibleOnMain.find(
                                (v) =>
                                    v.table === tableName ||
                                    (v.table instanceof Array && v.table.includes(tableName)) ||
                                    (v.tables instanceof Array && v.tables.includes(tableName))
                            );

                            if (vObj) vObj = vObj.value;
                        }
                        if (vObj) {
                            visible = AntCondition.isVisible(props.parentData ? props.parentData : formData, {
                                visible: vObj
                            });
                        }
                    }
                    if (visible && cnfItem.visibleSelf)
                        visible = AntCondition.isVisible(formData, {
                            visible: cnfItem.visibleSelf
                        });
                }
            }

            return visible;
        },
        [rawFlatItems, formData, props.type, props.parentData, isDisableField, AddressData]
    );

    const isRenderField = useCallback(
        (item) => {
            if (!formData) return true;

            var render = null;

            if (rawFlatItems instanceof Array) {
                var obj = rawFlatItems.find((e) => e.dataField === item.dataField || (item.name && e.name === item.name));
                if (obj) render = AntCondition.isRender(formData, obj);
            }
            if (render === false) return false;

            var obj = config.getCnfField(item.cnfField ? item.cnfField : item.dataField);
            if (obj) render = AntCondition.isRender(formData, obj);

            if (render === false) return false;

            return true;
        },
        [rawFlatItems, formData]
    );

    const isValidatableField = useCallback(
        (item) => {
            if (item.itemType === 'button') return false;
            if (item.itemType === 'antFormLink') return false;

            if (
                item.dataField &&
                formData &&
                formData.edit &&
                formData.edit.none_validate_fields instanceof Array &&
                formData.edit.none_validate_fields.includes(item.dataField)
            )
                return false;

            return !isDisableField(item);
        },
        [isDisableField, formData]
    );

    const customValidationCallback = useCallback((cb, params) => {
        return cb({ ...params, data: form.current ? form.current.instance.option('formData') : {} });
    }, []);

    const validateItem = useCallback(
        async (args) => {
            var fieldName = args.validator.option().dataField;
            if (!fieldName) return true;
            var item = formItems.find((i) => i.dataField == fieldName);
            if (item && item.disabled) return true;

            if (args.rule) {
                if (args.rule.customType === 'greaterThan' && typeof args.rule.customValue === 'number') {
                    return (
                        isNaN(args.value) ||
                        args.value === undefined ||
                        args.value === null ||
                        (typeof args.value === 'number' && parseFloat(args.value) > parseFloat(args.rule.customValue))
                    );
                }

                if (args.rule.customType === 'lessThan' && typeof args.rule.customValue === 'number') {
                    return (
                        isNaN(args.value) ||
                        args.value === undefined ||
                        args.value === null ||
                        (typeof args.value === 'number' && parseFloat(args.value) < parseFloat(args.rule.customValue))
                    );
                }

                if (args.rule.customType === 'min' && typeof args.rule.customValue === 'number') {
                    return (
                        isNaN(args.value) ||
                        args.value === undefined ||
                        args.value === null ||
                        (typeof args.value === 'number' && parseFloat(args.value) >= parseFloat(args.rule.customValue))
                    );
                }

                if (args.rule.customType === 'max' && typeof args.rule.customValue === 'number') {
                    return (
                        isNaN(args.value) ||
                        args.value === undefined ||
                        args.value === null ||
                        (typeof args.value === 'number' && parseFloat(args.value) <= parseFloat(args.rule.customValue))
                    );
                }
            }

            var obj = {
                id: formData ? formData.id : undefined
            };
            obj['check_' + fieldName] = true;
            obj['new_' + fieldName] = args.value;
            if (props.oldData) {
                obj['old_' + fieldName] = props.oldData[fieldName];
                if (obj['old_' + fieldName] === obj['new_' + fieldName]) return true;
            }

            var result = await props.API.postValidation(obj);

            if (actionStatus.current !== 'Saving') {
                if (result && result.data && typeof result.data.default === 'object') {
                    var data = result.data.default;
                    var keys = Object.keys(data);
                    for (let i = 0; i < keys.length; i++) {
                        const k = keys[i];
                        await setField(k, data[k], false);
                    }
                }
            }
            return result && result.data && result.data.isValid;
        },
        [formData, formItems, props.oldData, props.API]
    );

    const initFormItem = useCallback(
        (rItem) => {
            var item = JSON.parse(stringify(rItem));

            if (item.itemType !== 'button') item.template = 'renderItem';

            if (item.itemType === 'button') {
                item.horizontalAlignment = 'left';
                item.verticalAlignment = 'center';
                item.buttonOptions = {
                    ...item.buttonOptions,
                    onClick: rItem.onClick,
                    text: AntLocalization.translateText(item.text)
                };
            }

            item.rItem = JSON.parse(stringify(rItem));
            item.name = item.name ? item.name : item.dataField;

            if (rItem.dataField || rItem.cnfField || rItem.cnfTable) {
                var tableName = rItem.cnfTable ? rItem.cnfTable : props.table ? props.table : props.API ? props.API.entityName : null;

                var strField = rItem.cnfField ? rItem.cnfField : rItem.dataField;
                item.fieldConfig = config.getCnfField(strField, tableName);

                // if (item.fieldConfig && item.fieldConfig.cnfTable) {
                //     tableName = item.fieldConfig.cnfTable;

                //     var strField = item.fieldConfig.cnfField ? item.fieldConfig.cnfField : item.dataField;
                //     item.fieldConfig = config.getCnfField(strField, tableName);
                // }
            }

            var fieldConfig = item.fieldConfig;

            var rItem = item.rItem;
            var editorName = rItem.editorName;
            var editorType = rItem.editorType;

            item.editorConfig = null;

            if (editorName && (typeof editorName === 'object' || editorName instanceof Array)) {
                editorName = AntCondition.getValue(formData, editorName);
            }

            if (editorType && (typeof editorType === 'object' || editorType instanceof Array))
                editorType = AntCondition.getValue(formData, editorType);

            if (editorName) {
                item.editorConfig = config.getCnfEditor(editorName);

                if (item.editorConfig) {
                    editorName = item.editorConfig.name;
                    editorType = item.editorConfig.type;
                }
            }

            if (!editorType && fieldConfig && fieldConfig.editorType) editorType = fieldConfig.editorType;
            if (!editorName && fieldConfig && fieldConfig.editorName) editorName = fieldConfig.editorName;

            // if (!editorType) {
            if (!rItem.editorType && !item.editorType) {
                if (
                    (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) ||
                    (item.options && item.options.values instanceof Array)
                )
                    editorType = 'antSelectBox';
            }
            // }

            item.editorType = editorType;
            item.editorName = editorName;

            if (item.label instanceof Array) {
                var txtLabel = AntCondition.getValue(formData, item.label);
                txtLabel = AntLocalization.translateText(txtLabel);
                if (item.label && typeof item.label === 'object') item.label.text = txtLabel;
                else item.label = { text: txtLabel };
            } else item.label = { text: AntLocalization.translateText(item.label) };

            // Field adm hành chính: nhãn lấy từ envelope nước (đa ngôn ngữ); giữ nhãn config khi envelope
            // chưa nạp hoặc cấp không có trong envelope (getLevelLabelText trả '').
            var admLevel = AntAddress.admLevelFromField(item.dataField);
            if (admLevel && AddressData.isLoaded()) {
                var admLabel = AddressData.getLevelLabelText(admLevel);
                if (admLabel) {
                    if (!item.label || typeof item.label !== 'object') item.label = { text: admLabel };
                    else item.label.text = admLabel;
                }
            }

            if (item.options && item.options instanceof Array) {
                item.options = AntCondition.getValue(formData, item.options, item.dataField);
            }

            if (!item.options) item.options = {};
            if (item.underlined) item.options.stylingMode = 'underlined';

            var classes = [];
            if (item.bold) classes.push('ant-bold-editor');
            if (item.hideBorder || props.hideBorder) classes.push('ant-hide-border-editor');
            if (item.upperCase) classes.push('ant-upper-case-editor');
            if (item.lowerCase) classes.push('ant-lower-case-editor');
            if (item.alignment === 'right') classes.push('ant-align-right-editor');
            if (item.alignment === 'left') classes.push('ant-align-left-editor');
            if (item.alignment === 'center') classes.push('ant-align-center-editor');
            if (classes.length > 0) item.options.className = classes.join(' ');

            if (fieldConfig) {
                if (fieldConfig.label) {
                    let strText = AntLocalization.translateText(AntCondition.getValue(formData, fieldConfig.label));

                    if (!item.label) item.label = { text: strText };
                    else if (!item.label.text) item.label.text = strText;
                }
                if (!item.placeholder) item.placeholder = fieldConfig.placeholder;
                if (!item.type) item.type = fieldConfig.type;
                if (!item.dataType) item.dataType = fieldConfig.dataType;
                if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = fieldConfig.decimalDigit;
            }

            if (item.dataField === 'code' && props.API && props.API.entityDisplay) {
                let strText = AntLocalization.translateText(AntCondition.getValue(formData, props.API.entityDisplay));

                if (!item.label) item.label = { text: strText };
                else if (!item.label.text) item.label.text = strText;
            }

            if (item.editorConfig) {
                if (item.editorConfig.label) {
                    let strText = AntLocalization.translateText(AntCondition.getValue(formData, item.editorConfig.label));

                    if (!item.label) item.label = { text: strText };
                    else if (!item.label.text) item.label.text = strText;
                }
                if (!item.placeholder) item.placeholder = item.editorConfig.placeholder;
                if (!item.type) item.type = item.editorConfig.type;
                if (!item.dataType) item.dataType = item.editorConfig.dataType;
                if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = item.editorConfig.decimalDigit;
                // if (!item.lookup) item.lookup = item.editorConfig.lookup;
            }

            if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = AntLocalization.getCurrencyDecimalDigit();
            if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = 2;

            if (item.label && item.showLabel !== undefined) item.label.visible = item.showLabel;

            if (item.editorType == 'checkBox' || item.dataType == 'bool') {
                if (props.labelLocation === 'right' || props.allCheckBoxLeft || item.checkBoxLeft) {
                    if (!item.label) item.label = {};

                    item.label.oldText = item.label && item.label.text ? AntLocalization.translateText(item.label.text) : null;
                    item.label.text = undefined;
                    item.label.visible = false;
                }
            }
            if (!item.placeholder)
                item.placeholder =
                    fieldConfig && fieldConfig.label
                        ? AntLocalization.translateText(AntCondition.getValue(formData, fieldConfig.label))
                        : item.editorConfig && item.editorConfig.label
                        ? AntLocalization.translateText(AntCondition.getValue(formData, item.editorConfig.label))
                        : null;

            if (!item.placeholder && !Boolean(item.label?.visible) && item.label?.text) {
                item.placeholder = item.label.text;
            }
            if (!item.placeholder) item.placeholder = '...';

            item.render = isRenderField(item);
            item.visible = isVisibleField(item);

            var disabled = isDisableField(item);
            if (item.editorType === 'antFormLink') {
                // item.readOnly = true;
                // item.disabled = false;
            }

            // else if (item.itemType === 'button') {
            //     item.disabled = false;
            // }
            else item.disabled = disabled;

            item.canValidate = isValidatableField(item);

            if (!item.canValidate) item.validationRules = [];
            else if (item.dataField) {
                var newRules = [];

                var obj = config.getCnfField(item.dataField);

                if (item.clientRules !== null) {
                    if (obj && obj.clientRules && obj.clientRules instanceof Array) {
                        newRules = newRules.concat(
                            obj.clientRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                    if (item.clientRules instanceof Array) {
                        newRules = newRules.concat(
                            item.clientRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                }
                if (item.serverRules !== null) {
                    if (obj && obj.serverRules && obj.serverRules instanceof Array) {
                        newRules = newRules.concat(
                            obj.serverRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                    if (item.serverRules instanceof Array) {
                        newRules = newRules.concat(
                            item.serverRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                }

                if (item.exValidationRules && item.exValidationRules instanceof Array) {
                    newRules = newRules.concat(
                        item.exValidationRules.map((r) => {
                            if (r.type === 'async') {
                                var fItem = props.items.find((i) => i.dataField === item.dataField);
                                if (fItem && fItem.exValidationRules instanceof Array) {
                                    var found = fItem.exValidationRules.find((i) => i.type === 'async' && i.message === r.message);
                                    if (found) return found;
                                }
                            }
                            return { ...r };
                        })
                    );
                }

                for (let j = 0; j < newRules.length; j++) {
                    var r = newRules[j];
                    r.customType = r.type;
                    r.customValue = r.value;

                    if (r.type == 'async' && !r.validationCallback) {
                        r.validationCallback = validateItem;
                        if (!r.message) r.message = { vi: 'Đã tồn tại', en: 'Existed', fr: 'Existe déjà', es: 'Ya existe', id: 'Sudah ada', ja: '既に存在', zh: '已存在', ko: '이미 존재함', hi: 'पहले से मौजूद', ar: 'موجود بالفعل' };
                    } else if (r.type == 'async' && r.validationCallback) {
                        let oldCallback = r.validationCallback;

                        r.validationCallback = (e) => {
                            return customValidationCallback(oldCallback, e);
                        };
                    }

                    if (r.type == 'unique' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = validateItem;
                        r.message = { vi: 'Đã tồn tại', en: 'Existed', fr: 'Existe déjà', es: 'Ya existe', id: 'Sudah ada', ja: '既に存在', zh: '已存在', ko: '이미 존재함', hi: 'पहले से मौजूद', ar: 'موجود بالفعل' };
                    }

                    if (r.type == 'must-not-existed' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = validateItem;
                        r.message = { vi: 'Đã tồn tại', en: 'Existed', fr: 'Existe déjà', es: 'Ya existe', id: 'Sudah ada', ja: '既に存在', zh: '已存在', ko: '이미 존재함', hi: 'पहले से मौजूद', ar: 'موجود بالفعل' };
                    }

                    if (r.type == 'must-existed' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = validateItem;
                        r.message = { vi: 'Không tồn tại', en: 'Not existed', fr: 'N\'existe pas', es: 'No existe', id: 'Tidak ada', ja: '存在しません', zh: '不存在', ko: '존재하지 않음', hi: 'मौजूद नहीं', ar: 'غير موجود' };
                    }

                    if (r.type == 'greaterThan' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = validateItem;
                        r.message = `${AntLocalization.translateText({ vi: 'Phải', en: 'Must', fr: 'Doit', es: 'Debe', id: 'Harus', ja: '必須', zh: '必须', ko: '필수', hi: 'अवश्य', ar: 'يجب' })} > ${r.value}`;
                    }

                    if (r.type == 'lessThan' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = validateItem;
                        r.message = `${AntLocalization.translateText({ vi: 'Phải', en: 'Must', fr: 'Doit', es: 'Debe', id: 'Harus', ja: '必須', zh: '必须', ko: '필수', hi: 'अवश्य', ar: 'يجب' })} < ${r.value}`;
                    }

                    if (r.type == 'min' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = validateItem;
                        r.message = `${AntLocalization.translateText({ vi: 'Phải', en: 'Must', fr: 'Doit', es: 'Debe', id: 'Harus', ja: '必須', zh: '必须', ko: '필수', hi: 'अवश्य', ar: 'يجب' })} >= ${r.value}`;
                    }

                    if (r.type == 'max' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = validateItem;
                        r.message = `${AntLocalization.translateText({ vi: 'Phải', en: 'Must', fr: 'Doit', es: 'Debe', id: 'Harus', ja: '必須', zh: '必须', ko: '필수', hi: 'अवश्य', ar: 'يجب' })} <= ${r.value}`;
                    }

                    if (r.type == 'required' && !r.message) {
                        r.message = { vi: 'Không được trống', en: 'Required', fr: 'Obligatoire', es: 'No puede estar vacío', id: 'Tidak boleh kosong', ja: '空にできません', zh: '不能为空', ko: '비워둘 수 없습니다', hi: 'खाली नहीं हो सकता', ar: 'حقل مطلوب' };
                    }

                    if (r.type == 'stringLength') {
                        if (!r.message) {
                            if (r.min === undefined && r.max !== undefined)
                                r.message = `${AntLocalization.translateText({ vi: 'Tối đa', en: 'Maximum', fr: 'Maximum', es: 'Máximo', id: 'Maksimum', ja: '最大', zh: '最大', ko: '최대', hi: 'अधिकतम', ar: 'الحد الأقصى' })} ${
                                    r.max
                                } ${AntLocalization.translateText({ vi: 'ký tự', en: 'characters', fr: 'caractères', es: 'caracteres', id: 'karakter', ja: '文字', zh: '个字符', ko: '자', hi: 'वर्ण', ar: 'أحرف' })}`;
                            else if (r.max === undefined && r.min !== undefined)
                                r.message = `${AntLocalization.translateText({ vi: 'Tối thiểu', en: 'At least', fr: 'Au moins', es: 'Al menos', id: 'Minimal', ja: '最低', zh: '至少', ko: '최소', hi: 'कम से कम', ar: 'على الأقل' })} ${
                                    r.min
                                } ${AntLocalization.translateText({ vi: 'ký tự', en: 'characters', fr: 'caractères', es: 'caracteres', id: 'karakter', ja: '文字', zh: '个字符', ko: '자', hi: 'वर्ण', ar: 'أحرف' })}`;
                            else if (r.min !== undefined && r.max !== undefined)
                                r.message = `${AntLocalization.translateText({ vi: 'Yêu cầu từ', en: 'Must between', fr: 'Doit être entre', es: 'Debe estar entre', id: 'Harus antara', ja: '範囲内', zh: '必须在', ko: '사이여야 함', hi: 'के बीच होना चाहिए', ar: 'يجب أن يكون بين' })} ${r.min} -> ${
                                    r.max
                                } ${AntLocalization.translateText({ vi: 'ký tự', en: 'characters', fr: 'caractères', es: 'caracteres', id: 'karakter', ja: '文字', zh: '个字符', ko: '자', hi: 'वर्ण', ar: 'أحرف' })}`;
                        }
                    }

                    if (r.type == 'numberOnly') {
                        r.type = 'pattern';
                        r.pattern = /^\d+$/;
                        r.message = { vi: 'Chỉ được nhập số', en: 'Numberic only', fr: 'Chiffres uniquement', es: 'Solo números', id: 'Hanya angka', ja: '数字のみ', zh: '仅限数字', ko: '숫자만', hi: 'केवल अंक', ar: 'أرقام فقط' };
                    }

                    if (r.type == 'textOnly') {
                        r.type = 'pattern';
                        r.pattern = /[a-zA-Z\s]$/;
                        // r.message = 'Chỉ được nhập chữ';
                        r.message = { vi: 'Chỉ được nhập chữ', en: 'Text only', fr: 'Texte uniquement', es: 'Solo texto', id: 'Hanya teks', ja: 'テキストのみ', zh: '仅限文字', ko: '텍스트만', hi: 'केवल टेक्स्ट', ar: 'نص فقط' };
                    }

                    if (r.type == 'email') {
                        r.type = 'pattern';
                        r.pattern = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
                        // r.message = 'Không hợp lệ';
                        r.message = { vi: 'Không hợp lệ', en: 'Invalid Email', fr: 'Email invalide', es: 'Correo inválido', id: 'Email tidak valid', ja: '無効なメール', zh: '无效邮箱', ko: '잘못된 이메일', hi: 'अमान्य ईमेल', ar: 'بريد غير صالح' };
                    }

                    if (r.type == 'withoutSpace') {
                        r.type = 'pattern';
                        r.pattern = /^[^\s]+$/;
                        // r.message = 'Không được nhập khoảng trắng';
                        r.message = { vi: 'Không được nhập khoảng trắng', en: 'Cannot include whitespace', fr: 'Ne peut pas contenir d\'espaces', es: 'No puede incluir espacios', id: 'Tidak boleh ada spasi', ja: 'スペース不可', zh: '不能包含空格', ko: '공백 불가', hi: 'व्हाइटस्पेस नहीं', ar: 'لا يمكن أن يحتوي على مسافات' };
                    }

                    if (r.type == 'withoutSpecialKeys') {
                        r.type = 'pattern';
                        // r.message = 'Chứa ký tự đặc biệt';
                        r.message = { vi: 'Chứa ký tự đặc biệt', en: 'No special characters', fr: 'Caractères spéciaux', es: 'Contiene caracteres especiales', id: 'Berisi karakter khusus', ja: '特殊文字不可', zh: '不能包含特殊字符', ko: '특수문자 불가', hi: 'विशेष वर्ण नहीं', ar: 'لا يمكن أن يحتوي على أحرف خاصة' };
                    }
                    if (r.type == 'pattern' && !r.message) {
                        r.type = 'pattern';
                        // r.message = 'Không hợp lệ';
                        r.message = { vi: 'Không hợp lệ', en: 'Invalid', fr: 'Invalide', es: 'Inválido', id: 'Tidak valid', ja: '無効', zh: '无效', ko: '유효하지 않음', hi: 'अमान्य', ar: 'غير صالح' };
                    }

                    r.message = AntLocalization.translateText(r.message);

                    // if (item.label && item.label.text)
                    //   r.message = `${item.label.text} ${String(r.message).toLowerCase()}`;
                }

                if (item.byPassRequired || props.byPassRequired) newRules = newRules.filter((r) => r.type !== 'required');

                newRules.sort((a, b) => (a.index > b.index ? 1 : b.index > a.index ? -1 : 0));

                item.validationRules = newRules;
            }

            return item;
        },
        [formData, props.API, isRenderField, isVisibleField, isDisableField, isValidatableField, customValidationCallback, addrLoadTick]
    );

    const initFormItems = useCallback(() => {
        let ar = [];
        rawFlatItems.forEach((rItem) => {
            // var item = JSON.parse(stringify(rItem));
            ar.push(initFormItem(rItem));
        });

        return ar;
    }, [rawFlatItems, initFormItem]);

    // const formItems = useMemo(() => initFormItems(), [formData]);

    const initFormDisplayItems = useCallback(
        (items) => {
            var ar = [];
            if (items instanceof Array) {
                items.forEach((e) => {
                    var colSpan = AntCondition.getValue(formData, e.colSpan);
                    if (colSpan === undefined) colSpan = e.colSpanDefault;

                    var colCount = AntCondition.getValue(formData, e.colCount);
                    if (colCount === undefined) colCount = e.colCountDefault;

                    var label = AntCondition.getValue(formData, e.label);
                    label = AntLocalization.translateText(label);

                    if (e.items instanceof Array && e.itemType === 'group') {
                        let gItems = initFormDisplayItems(e.items);
                        // let gVisible = gItems.length > 0 && isVisibleField(e);

                        if (gItems.length > 0) {
                            let gItem = {
                                itemType: 'group',
                                showLabel: e.showLabel,
                                caption: label,
                                name: e.name,
                                colSpan: colSpan,
                                colCount: colCount,
                                items: gItems,
                                visible: isVisibleField(e),
                                collapsible: e.collapsible
                                // captionTemplate: 'renderGroupCaption'
                            };

                            // if (e.collapsible) gItem.template = 'renderCollapsibleGroup';

                            ar.push(gItem);
                        }
                    } else if (e.itemType === 'empty') {
                        ar.push({
                            itemType: 'empty',
                            colCount: colCount,
                            colSpan: colSpan,
                            visible: isVisibleField(e)
                        });
                    } else {
                        var item = formItems.find((item) => (e.name ? item.name === e.name : item.dataField === e.dataField));
                        if (item && item.render !== false) {
                            let disabled = isDisableField(e);

                            ar.push({
                                ...item,
                                colSpan: colSpan,
                                colCount: colCount,
                                visible: isVisibleField(e),
                                disabled: disabled
                            });
                        }
                    }
                });
            }

            if (props.inMultipleTabs) {
                if (ar.filter((i) => i.itemType === 'group' && !i.showLabel).length === 1) {
                    var found = ar.find((i) => i.caption);
                    if (found) found.caption = undefined;
                }
            }

            return ar;
        },
        [formData, formItems, isVisibleField, isDisableField, props.inMultipleTabs]
    );

    const initDefaultValue = useCallback(
        (item) => {
            if (rawFlatItems instanceof Array) {
                var rawItem = rawFlatItems.find((e) => e.dataField === item.dataField || (item.name && e.name === item.name));
                if (rawItem) {
                    var value = AntCondition.getDefault(formData, rawItem);
                    if (value !== undefined && value !== null) return value;
                }
            }

            var cnfItem = config.getCnfField(item.cnfField ? item.cnfField : item.dataField);
            if (cnfItem) {
                var value = AntCondition.getDefault(formData, cnfItem);
                if (value !== undefined && value !== null) return value;
            }
            return undefined;
        },
        [formData, rawFlatItems]
    );

    const initDefaultValues = useCallback(() => {
        var obj = {};

        if (rawFlatItems instanceof Array) {
            for (let i = 0; i < rawFlatItems.length; i++) {
                const item = rawFlatItems[i];
                var defaultValue = initDefaultValue(item);

                if (defaultValue !== undefined) {
                    if (typeof defaultValue === 'object' && defaultValue !== null && defaultValue.value !== undefined) {
                        obj[item.dataField] = defaultValue.value;
                        if (String(item.dataField).endsWith('_code')) {
                            var displayField = String(item.dataField).replace('_code', '_name');
                            obj[displayField] = defaultValue.display;
                        }
                    } else obj[item.dataField] = defaultValue;
                }
            }
        }

        if (props.default)
            Object.keys(props.default).forEach(function (key) {
                obj[key] = props.default[key];
            });

        return obj;
    }, [rawFlatItems, initDefaultValue, props.default]);

    const onFieldDataChanged = useCallback(
        async (args) => {
            var data = JSON.parse(stringify(args));
            var changedFields = Object.keys(data);
            var curObj = { ...formData, ...data };

            if (formItems instanceof Array) {
                formItems
                    .filter(
                        (item) =>
                            item.dataField &&
                            item.options &&
                            item.options.parentFields instanceof Array &&
                            item.options.parentFields.find((pField) => changedFields.includes(pField))
                    )
                    .forEach((item) => {
                        data[item.dataField] = null;
                    });

                var items = formItems
                    .filter(
                        (item) =>
                            item.dataField &&
                            ((item.formula && item.formula instanceof Array) ||
                                item.dataType === 'join' ||
                                item.dataType === 'fist' ||
                                item.dataType === 'last')
                    )
                    .map((item, index) => {
                        return {
                            ...item,
                            dataField: item.dataField,
                            formula: item.formula,
                            index: item.formulaIndex !== undefined ? item.formulaIndex : index
                        };
                    })
                    .sort((a, b) => (a.index > b.index ? 1 : -1));

                items.forEach((item) => {
                    var value;

                    if (item.formula instanceof Array) {
                        var fm = item.formula[0];
                        var defaultNullValue =
                            item.formula[1] !== undefined && item.formula[1] !== null && typeof item.formula[1] === 'number' ? item.formula[1] : 0;
                        value = Calculator.execNum(curObj, fm, defaultNullValue);
                    } else if (item.dataType === 'join') {
                        var fields = item.fields;
                        if (fields instanceof Array) {
                            value = fields
                                .map((f) => {
                                    if (!curObj) return null;

                                    return curObj[f];
                                })

                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                                .join(item.separator ? item.separator : ', ');
                        }
                    } else if (item.dataType === 'first') {
                        var fields = item.fields;
                        if (fields instanceof Array) {
                            value = fields
                                .map((f) => {
                                    if (!curObj) return null;

                                    return curObj[f];
                                })
                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                                .shift();
                        }
                    } else if (item.dataType === 'last') {
                        var fields = item.fields;
                        if (fields instanceof Array) {
                            value = fields
                                .map((f) => {
                                    if (!curObj) return null;

                                    return curObj[f];
                                })
                                .filter((f) => Boolean(f))
                                .map((f) => String(f))
                                .pop();
                        }
                    }

                    if (value !== undefined) {
                        curObj[item.dataField] = value;
                        // if (value !== data[item.dataField])

                        data[item.dataField] = value;
                    }
                });
            }

            if (Object.keys(data).length > 0) {
                if (formData) Object.assign(formData, data);
                setFormData((v) => Object.assign(v, data));
                // Trong context settings (bypassReevalOnFormDataChange) — KHÔNG forceRender:
                // forceRender bump shouldRender → formDisplayItems useMemo recompute (deps
                // có shouldRender + formData) → DevExtreme Form rebuild children → scroll
                // lên đầu. DevExtreme đã tự cập nhật value của field qua onValueChanged.
                if (!props.bypassReevalOnFormDataChange) forceRender();
                if (props.onFieldDataChanged) {
                    props.onFieldDataChanged(data, formData, (customData) => {
                        if (customData)
                            setFormData((v) => {
                                return { ...v, ...customData };
                            });
                    });
                }
            }
            if (props.onError) props.onError(null);
        },
        [formData, formItems, forceRender, props.onFieldDataChanged, props.onError]
    );

    const setField = useCallback(
        (field, value, raiseEvent) => {
            if (!formData) return;

            var previousValue = formData[field];
            setFormData((v) => Object.assign(v, { [field]: value }));

            if (raiseEvent !== false)
                onFieldDataChanged({
                    [field]: value,
                    oldValue: previousValue
                });
        },
        [formData, onFieldDataChanged]
    );

    const getField = useCallback(
        (field) => {
            return formData[field];
        },
        [formData]
    );

    const getId = useCallback(() => {
        return props.oldData ? props.oldData.id : null;
    }, [props.oldData]);

    const getChecksum = useCallback(() => {
        return props.oldData ? props.oldData.checksum : null;
    }, [props.oldData]);

    const getFormData = useCallback(() => {
        var obj = formData;
        if (!obj) return null;

        obj = JSON.parse(stringify(obj));
        Object.keys(obj).map((k) => {
            if (obj[k] === null || obj[k] === '') obj[k] = undefined;
        });

        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });
        return obj;
    }, [formData]);

    const getFirstFocusableField = useCallback(
        (afterField) => {
            if (rawFlatItems instanceof Array) {
                var foundAfterField = false;

                for (let i = 0; i < rawFlatItems.length; i++) {
                    const item = rawFlatItems[i];
                    if (item.dataField === afterField) {
                        foundAfterField = true;
                        continue;
                    }
                    if (!afterField || foundAfterField) {
                        var disabled = isDisableField(item);
                        var visible = isVisibleField(item);
                        if (visible && !disabled && item.dataField !== 'code' && item.dataField !== 'id') return item.dataField;
                    }
                }
            }
        },
        [rawFlatItems, isDisableField, isVisibleField]
    );

    const isFocusableField = useCallback(
        (fieldName) => {
            if (rawFlatItems instanceof Array) {
                for (let i = 0; i < rawFlatItems.length; i++) {
                    const item = rawFlatItems[i];
                    if (item.dataField === fieldName) {
                        var disabled = isDisableField(item);
                        var visible = isVisibleField(item);

                        return visible && !disabled && item.dataField !== 'id';
                    }
                }
            }

            return false;
        },
        [rawFlatItems, isDisableField, isVisibleField]
    );

    const focusToItem = useCallback(
        (fieldName) => {
            if (fieldName && form.current) {
                if (rawFlatItems instanceof Array) {
                    for (let i = 0; i < rawFlatItems.length; i++) {
                        const item = rawFlatItems[i];

                        if (item.dataField === fieldName) {
                            var itemName = item.name ? item.name : item.dataField;
                            var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;

                            var grouplabel = item.groupLabel;

                            if (item.groupLabel) {
                                if (item.groupLabel instanceof Array) {
                                    grouplabel = AntCondition.getValue(formData, item.groupLabel);
                                    grouplabel = AntLocalization.translateText(grouplabel);
                                }
                            }

                            if (!itemPath) itemPath = item && item.groupLabel ? item.groupLabel + '.' + itemName : null;
                            if (!itemPath) itemPath = itemName;

                            // var formItem = form.current.getEditor(itemName);
                            var formItem = document.getElementsByName(tableName + '_' + itemName)[0];
                            if (formItem) {
                                // formItem = formItem.dxTextBox('instance');
                                formItem.focus();

                                // form.current.updateDimensions();
                            }
                        }
                    }
                }
            }
        },
        [rawFlatItems, tableName]
    );

    const validate = useCallback(async () => {
        return new Promise(async (resolve) => {
            if (validateGroup.current && validateGroup.current.instance && ValidationEngine.getGroupConfig(validateGroup.current.instance)) {
                var res = validateGroup.current.instance.validate();
                // Rule bất đồng bộ (vd kiểm mã qua input/validate) còn chờ thì isValid=false:
                // bấm Lưu lúc đó sẽ báo "Dữ liệu không hợp lệ!" dù dữ liệu đúng. Chờ kết quả.
                if (res.status === 'pending' && res.complete) {
                    res.complete.then((r) => resolve(r.status === 'valid')).catch(() => resolve(false));
                } else {
                    resolve(res.isValid);
                }
            } else resolve(true);
        });
    }, []);

    const resetVisibility = useCallback(() => {
        let gr = [];
        let changed = false;

        if (form.current && form.current.instance) {
            if (rawFlatItems instanceof Array) {
                for (let i = 0; i < rawFlatItems.length; i++) {
                    const item = rawFlatItems[i];
                    let visible = isVisibleField(item);
                    let grouplabel = item.groupLabel;
                    if (item.groupLabel) {
                        if (item.groupLabel instanceof Array) {
                            grouplabel = AntCondition.getValue(formData, item.groupLabel);
                            grouplabel = AntLocalization.translateText(grouplabel);
                        }
                    }

                    let itemName = item.name ? item.name : item.dataField;
                    let itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;
                    if (!itemPath) itemPath = item && grouplabel ? grouplabel + '.' + itemName : null;
                    if (!itemPath) itemPath = itemName;
                    if (itemPath) {
                        let formItem = form.current.instance.itemOption(itemPath);
                        if (formItem) {
                            let currentVisible = formItem.visible;
                            if (currentVisible !== visible) {
                                changed = true;
                                form.current.instance.itemOption(itemPath, 'visible', visible);
                                if (props.onVisibleFieldChanged) props.onVisibleFieldChanged(itemName, visible);
                            }
                        }
                    }
                }
            }
        }
        return changed;
    }, [formData, rawFlatItems, isVisibleField, props.onVisibleFieldChanged]);

    const resetDisabled = useCallback(() => {
        var changed = false;

        if (form.current && form.current.instance) {
            if (rawFlatItems instanceof Array) {
                for (let i = 0; i < rawFlatItems.length; i++) {
                    const item = rawFlatItems[i];
                    var disabled = isDisableField(item);

                    let grouplabel = item.groupLabel;
                    if (item.groupLabel) {
                        if (item.groupLabel instanceof Array) {
                            grouplabel = AntCondition.getValue(formData, item.groupLabel);
                            grouplabel = AntLocalization.translateText(grouplabel);
                        }
                    }

                    var itemName = item.name ? item.name : item.dataField;
                    var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;
                    if (!itemPath) itemPath = item && grouplabel ? grouplabel + '.' + itemName : null;
                    if (!itemPath) itemPath = itemName;

                    var formItem = form.current.instance.itemOption(itemPath);

                    if (formItem) {
                        // if (item.itemType === 'button') {
                        //     var currentDisabled = formItem.disabled;
                        //     if (currentDisabled !== disabled) {
                        //         changed = true;

                        //         form.current.instance.itemOption(itemPath, 'buttonOptions', { ...formItem.buttonOptions, disabled: disabled });

                        //         if (props.onDisableFieldChanged) props.onDisableFieldChanged(itemName, disabled);
                        //     }
                        // } else

                        if (item.editorType === 'antFormLink') {
                            // var currentReadOnly = formItem.readOnly;
                            // if (currentReadOnly !== disabled) {
                            //     changed = true;
                            //     form.current.instance.itemOption(itemPath, 'readOnly', disabled);
                            //     if (props.onDisableFieldChanged) props.onDisableFieldChanged(itemName, disabled);
                            // }
                        } else {
                            var currentDisabled = formItem.disabled;
                            if (currentDisabled !== disabled) {
                                changed = true;
                                form.current.instance.itemOption(itemPath, 'disabled', disabled);
                                if (props.onDisableFieldChanged) props.onDisableFieldChanged(itemName, disabled);
                            }
                        }
                    }
                }
            }
        }
        return changed;
    }, [formData, rawFlatItems, isDisableField, props.onDisableFieldChanged]);

    const resetColSpan = useCallback(() => {
        var changed = false;

        if (form.current && form.current.instance) {
            if (rawFlatItems instanceof Array) {
                for (let i = 0; i < rawFlatItems.length; i++) {
                    const item = rawFlatItems[i];

                    var colSpan = AntCondition.getValue(formData, item.colSpan);
                    if (colSpan === undefined) colSpan = item.colSpanDefault;

                    let grouplabel = item.groupLabel;
                    if (item.groupLabel) {
                        if (item.groupLabel instanceof Array) {
                            grouplabel = AntCondition.getValue(formData, item.groupLabel);
                            grouplabel = AntLocalization.translateText(grouplabel);
                        }
                    }

                    var itemName = item.name ? item.name : item.dataField;
                    var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;
                    if (!itemPath) itemPath = item && grouplabel ? grouplabel + '.' + itemName : null;
                    if (!itemPath) itemPath = itemName;

                    if (itemPath) {
                        var formItem = form.current.instance.itemOption(itemPath);
                        if (formItem) {
                            var currentColSpan = formItem.colSpan;
                            if (currentColSpan !== colSpan) {
                                changed = true;
                                form.current.instance.itemOption(itemPath, 'colSpan', colSpan);
                            }
                        }
                    }
                }
            }
        }
        return changed;
    }, [formData, rawFlatItems]);

    const resetDefaultValue = useCallback(() => {
        var changed = false;
        if (formData) {
            if (rawFlatItems instanceof Array) {
                for (let i = 0; i < rawFlatItems.length; i++) {
                    const item = rawFlatItems[i];

                    if (item.itemType !== 'button') {
                        if (formData[item.dataField] === undefined) {
                            var defaultValue = initDefaultValue(item);
                            if (defaultValue !== undefined) {
                                let obj = {};

                                if (typeof defaultValue === 'object' && defaultValue !== null && defaultValue.value !== undefined) {
                                    obj[item.dataField] = defaultValue.value;

                                    if (String(item.dataField).endsWith('_code')) {
                                        var displayField = String(item.dataField).replace('_code', '_name');
                                        obj[displayField] = defaultValue.display;
                                    }
                                } else obj[item.dataField] = defaultValue;
                                setFormData((v) => Object.assign(v, obj));

                                if (form.current && form.current.instance) {
                                    var itemName = item.name ? item.name : item.dataField;
                                    var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;

                                    var grouplabel = item.groupLabel;

                                    if (item.groupLabel) {
                                        if (item.groupLabel instanceof Array) {
                                            grouplabel = AntCondition.getValue(formData, item.groupLabel);
                                            grouplabel = AntLocalization.translateText(grouplabel);
                                        }
                                    }

                                    if (!itemPath) itemPath = item && item.groupLabel ? grouplabel + '.' + itemName : null;
                                    if (!itemPath) itemPath = itemName;

                                    form.current.instance.itemOption(itemPath, 'value', defaultValue);
                                }
                                if (props.onDefaultValueChanged) props.onDefaultValueChanged(itemName, defaultValue);
                            }
                        }
                    }
                }
            }
        }
        return changed;
    }, [formData, rawFlatItems, initDefaultValue, props.onDefaultValueChanged]);

    const resetUI = useCallback(
        async (withoutUpdate) => {
            // if (!withoutUpdate) beginUpdate();
            // if (form.current && form.current.instance) {
            await resetDefaultValue();
            await resetVisibility();
            await resetDisabled();
            await resetColSpan();
            if (form.current && form.current.instance) form.current.instance.updateDimensions();
            // }
            // if (!withoutUpdate) endUpdate();
        },
        [resetDefaultValue, resetVisibility, resetDisabled, resetColSpan]
    );

    const getDataForUpdate = useCallback(() => {
        var obj = {};
        var edit = formData.edit;
        var actions = formData.actions;

        var prepareLookups =
            formLookups.current instanceof Array && formLookups.current.length > 0
                ? formLookups.current
                : formData && formData.lookups instanceof Array
                ? formData.lookups
                : [];

        Object.keys(formData).forEach(function (key) {
            if (formItems instanceof Array) {
                var item = formItems.find((e) => e.dataField === key);
                if (item && item.viewOnly) return;
            }

            var fObj = formData[key];
            if (
                fObj !== edit &&
                fObj !== actions &&
                fObj !== prepareLookups &&
                fObj !== props.oldData &&
                (!props.oldData || props.oldData[key] === undefined || stringify(fObj) !== stringify(props.oldData[key]))
            )
                obj[key] = fObj;
        });

        Object.keys(obj).forEach((k) => {
            if (k === 'actions' || k === 'lookups' || k === 'checksum' || k === 'recalc_checksum' || k === 'updated_at') obj[k] = undefined;
            if (typeof obj[k] === 'object' && obj[k] !== null && obj[k] instanceof Array === false) obj[k] = undefined;
        });

        if (props.parentFK && Object.keys(props.parentFK).length > 0) {
            obj = Object.assign(obj, props.parentFK);
        }

        if (props.parentData && Object.keys(props.parentData).length > 0 && props.copyFromParentFields instanceof Array) {
            props.copyFromParentFields.forEach((field) => {
                if (typeof field === 'object') {
                    var parentField = field.field;
                    var aliasField = field.alias ? field.alias : field.field;

                    if (props.parentData && props.parentData[parentField] !== undefined && props.parentData[parentField] !== null) {
                        if (field.when && typeof field.when === 'object') {
                            var isValid = AntCondition.isValid(props.parentData, {
                                when: field.when,
                                whenType: field.whenType
                            });
                            if (!isValid) return;
                        }
                        obj[aliasField] = props.parentData[parentField];
                    }
                } else if (props.parentData && props.parentData[field] !== undefined && props.parentData[field] !== null)
                    obj[field] = props.parentData[field];
            });
        }

        if (obj && props.postFields instanceof Array)
            Object.keys(obj).forEach((k) => {
                var found = props.postFields.find((field) => {
                    if (typeof field === 'object') return field.field === k;
                    else return field === k;
                });

                if (!found) obj[k] = undefined;
                else {
                    props.postFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var rawField = field.field;
                            var postField = field.alias;
                            if (rawField === k) {
                                obj[postField] = obj[rawField];
                                obj[rawField] = undefined;
                            }
                        }
                    });
                }
            });

        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });

        return { ...obj };
    }, [formData, formItems, props.oldData, props.parentFK, props.parentData, props.copyFromParentFields, props.postFields]);

    const getDataForCreate = useCallback(() => {
        var obj = {};

        var prepareLookups =
            formLookups.current instanceof Array && formLookups.current.length > 0
                ? formLookups.current
                : formData && formData.lookups instanceof Array
                ? formData.lookups
                : [];

        Object.keys(formData).forEach(function (key) {
            if (formItems instanceof Array) {
                var item = formItems.find((e) => e.dataField === key);
                if (item && item.viewOnly) return;
            }

            var fObj = formData[key];
            if (fObj !== prepareLookups) obj[key] = fObj;
        });

        Object.keys(obj).forEach((k) => {
            if (k === 'actions' || k === 'lookups') obj[k] = undefined;
            if (typeof obj[k] === 'object' && obj[k] !== null && obj[k] instanceof Array === false) obj[k] = undefined;
        });

        if (obj && props.postFields instanceof Array)
            Object.keys(obj).forEach((k) => {
                var found = props.postFields.find((field) => {
                    if (typeof field === 'object') return field.field === k;
                    else return field === k;
                });

                if (!found) obj[k] = undefined;
            });

        if (props.parentFK && Object.keys(props.parentFK).length > 0) {
            obj = Object.assign(obj, props.parentFK);
        }

        if (props.parentData && Object.keys(props.parentData).length > 0 && props.copyFromParentFields instanceof Array) {
            props.copyFromParentFields.forEach((field) => {
                if (typeof field === 'object') {
                    var parentField = field.field;
                    var aliasField = field.alias ? field.alias : field.field;

                    if (props.parentData && props.parentData[parentField] !== undefined && props.parentData[parentField] !== null) {
                        if (field.when && typeof field.when === 'object') {
                            var isValid = AntCondition.isValid(props.parentData, {
                                when: field.when,
                                whenType: field.whenType
                            });
                            if (!isValid) return;
                        }
                        obj[aliasField] = props.parentData[parentField];
                    }
                } else if (props.parentData && props.parentData[field] !== undefined && props.parentData[field] !== null)
                    obj[field] = props.parentData[field];
            });
        }

        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });

        return { ...obj };
    }, [formData, formItems, props.postFields, props.parentFK, props.parentData, props.copyFromParentFields]);

    const onAction = useCallback(
        async (button) => {
            var error = null;
            if (button && button.id == 'btnSave') {
                actionStatus.current = 'Saving';
                var valid = await validate();
                if (valid && props.onValidation) valid = await props.onValidation();

                if (!valid) {
                    actionStatus.current = null;
                    return false;
                }

                if (props.type === 'Update') {
                    var newObj = getDataForUpdate();

                    if (newObj && typeof newObj === 'object' && Object.keys(newObj).length > 0) {
                        if (!newObj || Object.keys(newObj).length === 0)
                            error = AntLocalization.translateText({ vi: 'Vui lòng nhập thông tin !', en: 'Please input data !', fr: 'Veuillez saisir des données !', es: '¡Por favor ingrese datos!', id: 'Silakan masukkan data!', ja: 'データを入力してください！', zh: '请输入数据！', ko: '데이터를 입력하세요!', hi: 'कृपया डेटा दर्ज करें!', ar: 'الرجاء إدخال البيانات!' });
                        else {
                            if (props.onSaving) newObj = props.onSaving(newObj, formData);

                            let result;
                            if (props.onProcess)
                                result = await props.onProcess(
                                    {
                                        id: getId(),
                                        checksum: getChecksum()
                                    },
                                    newObj
                                );
                            else {
                                result = await props.API.postUpdateValidation(
                                    {
                                        id: getId(),
                                        checksum: getChecksum()
                                    },
                                    newObj,
                                    props.validationURL
                                );
                                error = config.translateFirstError(result, { vi: 'Dữ liệu không hợp lệ!', en: 'Invalid data !', fr: 'Données invalides !', es: '¡Datos inválidos!', id: 'Data tidak valid!', ja: '無効なデータ！', zh: '无效数据！', ko: '잘못된 데이터!', hi: 'अमान्य डेटा!', ar: 'بيانات غير صالحة!' });

                                if (!error) {
                                    result = await props.API.postUpdate(
                                        {
                                            id: getId(),
                                            checksum: getChecksum()
                                        },
                                        newObj,
                                        { url: props.actionURL }
                                    );
                                }
                            }

                            if (!result || result.error || !result.data || !result.data.updated)
                                error = config.translateFirstError(result, { vi: 'Dữ liệu không hợp lệ!', en: 'Invalid data !', fr: 'Données invalides !', es: '¡Datos inválidos!', id: 'Data tidak valid!', ja: '無効なデータ！', zh: '无效数据！', ko: '잘못된 데이터!', hi: 'अमान्य डेटा!', ar: 'بيانات غير صالحة!' });
                            else if (props.onSaved) props.onSaved(result.data);
                        }
                    }
                } else if (props.type === 'Create') {
                    var newObj = getDataForCreate();
                    if (newObj && typeof newObj === 'object' && Object.keys(newObj).length > 0) {
                        if (props.onSaving) newObj = props.onSaving(newObj, formData);

                        if (!newObj || Object.keys(newObj).length === 0)
                            error = AntLocalization.translateText({ vi: 'Vui lòng nhập thông tin !', en: 'Please input data !', fr: 'Veuillez saisir des données !', es: '¡Por favor ingrese datos!', id: 'Silakan masukkan data!', ja: 'データを入力してください！', zh: '请输入数据！', ko: '데이터를 입력하세요!', hi: 'कृपया डेटा दर्ज करें!', ar: 'الرجاء إدخال البيانات!' });
                        else {
                            let result;
                            if (props.onProcess) result = await props.onProcess(newObj);
                            else {
                                result = await props.API.postCreateValidation(newObj, props.validationURL);
                                error = config.translateFirstError(result, { vi: 'Dữ liệu không hợp lệ!', en: 'Invalid data !', fr: 'Données invalides !', es: '¡Datos inválidos!', id: 'Data tidak valid!', ja: '無効なデータ！', zh: '无效数据！', ko: '잘못된 데이터!', hi: 'अमान्य डेटा!', ar: 'بيانات غير صالحة!' });

                                if (!error) {
                                    result = await props.API.postCreate(newObj, { url: props.actionURL });
                                }
                            }

                            if (!result || result.error || !result.data || !result.data.inserted)
                                error = config.translateFirstError(result, { vi: 'Dữ liệu không hợp lệ!', en: 'Invalid data !', fr: 'Données invalides !', es: '¡Datos inválidos!', id: 'Data tidak valid!', ja: '無効なデータ！', zh: '无效数据！', ko: '잘못된 데이터!', hi: 'अमान्य डेटा!', ar: 'بيانات غير صالحة!' });
                            else if (props.onSaved) props.onSaved(result.data);
                        }
                    }
                } else if (props.type === 'Custom') {
                    var newObj = getDataForCreate();
                    if (newObj && typeof newObj === 'object' && Object.keys(newObj).length > 0) {
                        if (props.onSaving) newObj = props.onSaving(newObj, formData);

                        if (!newObj || Object.keys(newObj).length === 0)
                            error = AntLocalization.translateText({ vi: 'Vui lòng nhập thông tin !', en: 'Please input data !', fr: 'Veuillez saisir des données !', es: '¡Por favor ingrese datos!', id: 'Silakan masukkan data!', ja: 'データを入力してください！', zh: '请输入数据！', ko: '데이터를 입력하세요!', hi: 'कृपया डेटा दर्ज करें!', ar: 'الرجاء إدخال البيانات!' });
                        else {
                            let result;
                            if (props.onProcess) result = await props.onProcess(newObj);
                            else {
                                result = await props.API.postCustomValidation(newObj, props.validationURL);
                                error = config.translateFirstError(result, { vi: 'Dữ liệu không hợp lệ!', en: 'Invalid data !', fr: 'Données invalides !', es: '¡Datos inválidos!', id: 'Data tidak valid!', ja: '無効なデータ！', zh: '无效数据！', ko: '잘못된 데이터!', hi: 'अमान्य डेटा!', ar: 'بيانات غير صالحة!' });

                                if (!error) {
                                    result = await props.API.postCustomAction(newObj, { url: props.actionURL });
                                }
                            }

                            if (!result || result.error)
                                error = config.translateFirstError(result, { vi: 'Dữ liệu không hợp lệ!', en: 'Invalid data !', fr: 'Données invalides !', es: '¡Datos inválidos!', id: 'Data tidak valid!', ja: '無効なデータ！', zh: '无效数据！', ko: '잘못된 데이터!', hi: 'अमान्य डेटा!', ar: 'بيانات غير صالحة!' });
                            else if (props.onSaved) props.onSaved(result.data);
                        }
                    }
                }
            }

            if (error) {
                if (props.onError) props.onError({ vi: 'Không thể cập nhật thông tin !', en: 'Can not update data !', fr: 'Impossible de mettre à jour !', es: '¡No se puede actualizar!', id: 'Tidak dapat memperbarui!', ja: '更新できません！', zh: '无法更新！', ko: '업데이트 불가!', hi: 'अपडेट नहीं कर सकते!', ar: 'لا يمكن التحديث!' }, error);
                actionStatus.current = null;
                return false;
            }

            actionStatus.current = null;
            return true;
        },
        [
            formData,
            props.validationURL,
            props.actionURL,
            props.type,
            validate,
            getDataForUpdate,
            getDataForCreate,
            getId,
            getChecksum,
            props.onValidation,
            props.onSaving,
            props.onProcess,
            props.onSaved,
            props.API,
            props.onError
        ]
    );

    const isHadNewData = useCallback(
        async (id, code) => {
            if (!id && !code) return;

            var oldChecksum = formData && formData.checksum ? formData.checksum : undefined;
            return new Promise(async (resolve) => {
                var obj = null;
                if (props.prepare !== false && props.API && props.API.postGetChecksum) obj = await props.API.postGetChecksum(id, code);

                resolve(obj && obj.checksum !== oldChecksum);
            });
        },
        [formData, props.prepare, props.API]
    );

    const renderFormLink = useCallback((args) => {}, []);

    // const renderCollapsibleGroup = useCallback((args) => {
    //     console.log('ant-log-renderCollapsibleGroup : ', args);
    //     return <div>AAAAA</div>;
    // });

    const renderGroupCaption = useCallback((args) => {
        console.log('ant-log-renderGroupCaption : ', args);
        return <div>AAAAA</div>;
    });

    const renderItem = useCallback(
        (args) => {
            let item = formItems.find((i) => (args.name ? i.name === args.name && i.dataField === args.dataField : i.dataField === args.dataField));
            if (!item) return <div />;

            let itemIndex = formItems.findIndex((i) =>
                args.name ? i.name === args.name && i.dataField === args.dataField : i.dataField === args.dataField
            );

            let itemRef = formDisplayItemRefs[itemIndex];
            item = initFormItem(item.rItem);

            var fieldConfig = item.fieldConfig;
            var editorConfig = item.editorConfig;

            var prepareLookups =
                formLookups.current instanceof Array && formLookups.current.length > 0
                    ? formLookups.current
                    : formData && formData.lookups instanceof Array
                    ? formData.lookups
                    : [];

            if (item.editorType == 'imageUrl') {
                var voucherModuleSingle = item.voucherModule || (props.API ? props.API.moduleName : '');
                return (
                    <AntImageUrl
                        value={formData ? formData[item.dataField] : ''}
                        onChange={(patchOrUrl) => {
                            // AntImageUrl có thể trả về string (URL đơn) hoặc patch object (clear multi-field).
                            if (patchOrUrl && typeof patchOrUrl === 'object') {
                                onFieldDataChanged(patchOrUrl);
                            } else {
                                onFieldDataChanged({ [item.dataField]: patchOrUrl });
                            }
                        }}
                        voucherModule={voucherModuleSingle}
                        voucherType={item.voucherType || (props.API ? props.API.entityName : tableName)}
                        voucherID={formData ? formData.id : null}
                        voucherCode={formData ? formData.code : null}
                        targetField={item.target_field || item.targetField}
                        dataField={item.dataField}
                        shortPathField={item.shortPathField || item.short_path_field}
                        readOnly={Boolean(item.disabled)}
                        width={item.width || 120}
                        height={item.height || 120}
                        generateAction={item.generateAction || item.generate_action}
                        generating={(item.target_field || item.targetField) === 'avatar' ? formData?.avatar_generating : false}
                        onGenerateQueued={props.onGenerateQueued}
                        onUploaded={props.onUploaded}
                    />
                );
            }

            if (item.editorType == 'imageUrlList') {
                var voucherModuleList = item.voucherModule || (props.API ? props.API.moduleName : '');
                return (
                    <AntImageUrlList
                        value={formData || {}}
                        onChange={(patch) => {
                            onFieldDataChanged(patch);
                        }}
                        sourceFields={item.sourceFields || []}
                        voucherModule={voucherModuleList}
                        voucherType={item.voucherType || (props.API ? props.API.entityName : tableName)}
                        voucherID={formData ? formData.id : null}
                        voucherCode={formData ? formData.code : null}
                        readOnly={Boolean(item.disabled)}
                        columns={item.columns || 5}
                        thumbSize={item.thumbSize || 90}
                        onUploaded={props.onUploaded}
                    />
                );
            }

            if (item.editorType == 'textArea') {
                // Kéo góc dưới để đổi chiều cao (resize dọc): khung ô cao tự do (height auto), chiều cao ban đầu
                // (options.height, mặc định 83) đặt cho ô nhập bên trong. autoResizeEnabled thì DevExtreme tự lo.
                const textAreaOptions = item.options || {};
                const autoResize = Boolean(textAreaOptions.autoResizeEnabled);
                const optionHeight = textAreaOptions.height !== undefined ? textAreaOptions.height : 83;
                const initialHeight = typeof optionHeight === 'number' || /^\d+(px)?$/.test(String(optionHeight)) ? parseInt(optionHeight, 10) : 83;
                const elementAttr = textAreaOptions.elementAttr || {};
                return (
                    <TextArea
                        ref={itemRef}
                        height={83}
                        {...textAreaOptions}
                        {...(autoResize
                            ? {}
                            : {
                                  height: 'auto',
                                  elementAttr: {
                                      ...elementAttr,
                                      class: ((elementAttr.class ? elementAttr.class + ' ' : '') + 'ant-textarea-resizable').trim()
                                  },
                                  onContentReady: (e) => {
                                      const input = e.element && e.element.querySelector('textarea');
                                      // Giữ chiều cao người dùng đã kéo qua các lần vẽ lại.
                                      if (input && !input.dataset.antResizeInit && initialHeight > 0) {
                                          input.dataset.antResizeInit = '1';
                                          input.style.height = Math.max(36, initialHeight - 2) + 'px';
                                      }
                                      if (textAreaOptions.onContentReady) textAreaOptions.onContentReady(e);
                                  }
                              })}
                        name={tableName + '_' + item.name}
                        readOnly={Boolean(item.disabled)}
                        focusStateEnabled={!Boolean(item.disabled)}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </TextArea>
                );
            }

            if (item.editorType == 'checkBox' || item.dataType == 'bool' || String(item.dataField).startsWith('is_')) {
                var obj = {};
                if (props.labelLocation === 'right' || props.allCheckBoxLeft || item.checkBoxLeft) {
                    obj.text = item.label && item.label.oldText ? AntLocalization.translateText(item.label.oldText) : '';
                    obj.width = '100%';
                }

                var hintText = item.hint ? AntLocalization.translateText(item.hint) : null;

                var checkBoxEl = (
                    <CheckBox
                        ref={itemRef}
                        {...item.options}
                        {...obj}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        defaultValue={formData ? formData[item.dataField] === 1 : false}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value ? 1 : 0
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </CheckBox>
                );

                if (hintText) {
                    return (
                        <div className="ant-checkbox-with-hint">
                            {checkBoxEl}
                            <div className="ant-checkbox-hint">{hintText}</div>
                        </div>
                    );
                }

                return checkBoxEl;
            }

            if (item.dataType === 'month' || item.editorType == 'antMonthBox') {
                var showClearButton = !item.disabled && (item.showClearButton !== undefined ? item.showClearButton : true);
                var showDropDownButton = !item.disabled && (item.showDropDownButton !== undefined ? item.showDropDownButton : true);

                return (
                    <AntMonthBox
                        ref={itemRef}
                        placeholder={!Boolean(item.label?.visible) && item.placeholder ? item.placeholder : '...'}
                        showClearButton={showClearButton}
                        showDropDownButton={showDropDownButton}
                        {...item.options}
                        showNextMonths={item.options?.showNextMonths}
                        name={tableName + '_' + item.name}
                        disabled={item.disabled}
                        focusStateEnabled={!Boolean(item.disabled)}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </AntMonthBox>
                );
            }

            if (item.dataType === 'year' || item.editorType == 'antYearBox') {
                var showClearButton = !item.disabled && (item.showClearButton !== undefined ? item.showClearButton : true);
                var showDropDownButton = !item.disabled && (item.showDropDownButton !== undefined ? item.showDropDownButton : true);

                return (
                    <AntYearBox
                        ref={itemRef}
                        placeholder={!Boolean(item.label?.visible) && item.placeholder ? item.placeholder : '...'}
                        showClearButton={showClearButton}
                        showDropDownButton={showDropDownButton}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        disabled={item.disabled}
                        focusStateEnabled={!Boolean(item.disabled)}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </AntYearBox>
                );
            }

            if (item.editorType === 'antAddress') {
                var _addrPrefix =
                    (item.options && item.options.addressPrefix) ||
                    String(item.dataField).replace(/(address_search|address|adm1_code)$/, '');
                return (
                    <AntAddressField
                        prefix={_addrPrefix}
                        values={formData}
                        disabled={item.disabled}
                        API={props.API}
                        country={addrCountry}
                        locale={addrLocale}
                        onChange={(obj) => onFieldDataChanged(obj)}
                    />
                );
            }

            if (String(item.dataField).endsWith('adm1_code')) {
                if (AddressData.getMode() === 'postal') return null; // nước postal (vd SG) — không cascade hành chính
                return (
                    <AntSelectBox
                        ref={itemRef}
                        formRef={form}
                        dataField={item.dataField}
                        name={tableName + '_' + item.name}
                        API={props.API}
                        isRemote={false}
                        useCustomStore={true}
                        defaultValue={formData ? formData[item.dataField] : null}
                        showClearButton={!item.disabled}
                        options={{
                            ...item.options,
                            dataSource: AddressData.getProvinces(),
                            valueExpr: 'code',
                            displayExpr: 'name'
                        }}
                        focusStateEnabled={!Boolean(item.disabled)}
                        validationRules={item.disabled ? [] : item.validationRules}
                        onValueChanged={(e) => {
                            var provinceCodeField = String(item.dataField);
                            var districtCodeField = String(item.dataField).replace('adm1_code', 'adm2_code');
                            var wardCodeField = String(item.dataField).replace('adm1_code', 'adm3_code');

                            var provinceNameField = String(provinceCodeField).replace('adm1_code', 'adm1_name');
                            var districtNameField = String(districtCodeField).replace('adm2_code', 'adm2_name');
                            var wardNameField = String(wardCodeField).replace('adm3_code', 'adm3_name');

                            onFieldDataChanged({
                                [provinceCodeField]: e.value,
                                [provinceNameField]: e.value ? e.rowData['name'] : null,
                                [districtCodeField]: null,
                                [districtNameField]: null,
                                [wardCodeField]: null,
                                [wardNameField]: null
                            });
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    />
                );
            }
            if (String(item.dataField).endsWith('adm2_code')) {
                if (!AddressData.isLoaded() || AddressData.getLevelCount() < 2) return null;
                var provinceField = String(item.dataField).replace('adm2_code', 'adm1_code');
                var adm1_code = formData ? formData[provinceField] : null;

                return (
                    <AntSelectBox
                        ref={itemRef}
                        formRef={form}
                        dataField={item.dataField}
                        name={tableName + '_' + item.name}
                        API={props.API}
                        isRemote={false}
                        useCustomStore={true}
                        defaultValue={formData ? formData[item.dataField] : null}
                        showClearButton={!item.disabled}
                        options={{
                            ...item.options,
                            dataSource: AddressData.getDistricts(adm1_code),
                            valueExpr: 'code',
                            displayExpr: 'name'
                        }}
                        focusStateEnabled={!Boolean(item.disabled)}
                        validationRules={item.disabled ? [] : item.validationRules}
                        onValueChanged={(e) => {
                            var districtCodeField = String(item.dataField);
                            var wardCodeField = String(item.dataField).replace('adm2_code', 'adm3_code');

                            var districtNameField = String(districtCodeField).replace('adm2_code', 'adm2_name');
                            var wardNameField = String(wardCodeField).replace('adm3_code', 'adm3_name');

                            onFieldDataChanged({
                                [districtCodeField]: e.value,
                                [districtNameField]: e.value ? e.rowData['name'] : null,
                                [wardCodeField]: null,
                                [wardNameField]: null
                            });
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    />
                );
            }
            if (String(item.dataField).endsWith('adm3_code')) {
                if (!AddressData.isLoaded() || AddressData.getLevelCount() < 3) return null;
                var districtField = String(item.dataField).replace('adm3_code', 'adm2_code');
                var adm2_code = formData ? formData[districtField] : null;

                return (
                    <AntSelectBox
                        ref={itemRef}
                        formRef={form}
                        dataField={item.dataField}
                        name={tableName + '_' + item.name}
                        API={props.API}
                        isRemote={false}
                        useCustomStore={true}
                        defaultValue={formData ? formData[item.dataField] : null}
                        showClearButton={!item.disabled}
                        options={{
                            ...item.options,
                            dataSource: AddressData.getWards(adm2_code),
                            valueExpr: 'code',
                            displayExpr: 'name'
                        }}
                        focusStateEnabled={!Boolean(item.disabled)}
                        validationRules={item.disabled ? [] : item.validationRules}
                        onValueChanged={(e) => {
                            var wardCodeField = String(item.dataField);
                            var wardNameField = String(wardCodeField).replace('adm3_code', 'adm3_name');

                            onFieldDataChanged({
                                [wardCodeField]: e.value,
                                [wardNameField]: e.value ? e.rowData['name'] : null
                            });
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    />
                );
            }

            if (item.editorType == 'antFilterBuilder') {
                var tableName =
                    item.options && item.options.table
                        ? item.options.table
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                        ? editorConfig.lookup.table
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                        ? fieldConfig.lookup.table
                        : null;

                var columns =
                    item.options && item.options.columns
                        ? item.options.columns
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.columns
                        ? editorConfig.lookup.columns
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.columns
                        ? fieldConfig.lookup.columns
                        : null;

                var height =
                    item.options && item.options.height !== undefined
                        ? item.options.height
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                        ? editorConfig.lookup.height
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                        ? fieldConfig.lookup.height
                        : null;

                var width =
                    item.options && item.options.width !== undefined
                        ? item.options.width
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                        ? editorConfig.lookup.width
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                        ? fieldConfig.lookup.width
                        : undefined;

                var actionItems =
                    item.options && item.options.actionItems instanceof Array
                        ? item.options.actionItems
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.actionItems instanceof Array
                        ? editorConfig.lookup.actionItems
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.actionItems instanceof Array
                        ? fieldConfig.lookup.actionItems
                        : undefined;

                return (
                    <AntFilterBuilder
                        ref={itemRef}
                        formRef={form}
                        dataField={item.dataField}
                        API={props.API}
                        name={tableName + '_' + item.name}
                        value={formData ? formData[item.dataField] : null}
                        editorOptions={{
                            stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                            className: item.options && item.options.className ? item.options.className : undefined
                        }}
                        builderOptions={{
                            ...item.options,
                            table: tableName,
                            columns: columns
                        }}
                        height={height}
                        width={width}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                    />
                );
            }

            if (item.editorType == 'dxSelectBox') {
                // dần bỏ

                var url =
                    item.options && item.options.url
                        ? item.options.url
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                        ? editorConfig.lookup.url
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                        ? fieldConfig.lookup.url
                        : null;

                var isRemote =
                    item.options && item.options.isRemote !== undefined
                        ? item.options.isRemote
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                        ? editorConfig.lookup.isRemote
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                        ? fieldConfig.lookup.isRemote
                        : Boolean(url);

                var searchConditions =
                    item.options && item.options.searchConditions !== undefined
                        ? item.options.searchConditions
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                        ? editorConfig.lookup.searchConditions
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                        ? fieldConfig.lookup.searchConditions
                        : null;

                var lookupClientValues =
                    item.options && item.options.values !== undefined
                        ? item.options.values
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                        ? editorConfig.lookup.values
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                        ? fieldConfig.lookup.values
                        : null;

                lookupClientValues =
                    lookupClientValues instanceof Array && lookupClientValues.length > 0
                        ? lookupClientValues.map((o) => {
                              if (typeof o === 'string') return { code: o };
                              return o;
                          })
                        : typeof lookupClientValues === 'object' && lookupClientValues !== null
                        ? [lookupClientValues]
                        : typeof lookupClientValues === 'string' && lookupClientValues !== null
                        ? [{ code: lookupClientValues }]
                        : [];

                lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

                if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                    if (item.options && item.options.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = item.options.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                    if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                }

                var lookupServerName =
                    item.options && item.options.lookupServerName !== undefined
                        ? item.options.lookupServerName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                        ? editorConfig.lookup.serverName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                        ? fieldConfig.lookup.serverName
                        : item.dataField;

                var lookupClientName =
                    item.options && item.options.lookupClientName !== undefined
                        ? item.options.lookupClientName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                        ? editorConfig.lookup.clientName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                        ? fieldConfig.lookup.clientName
                        : item.dataField;

                var allowNew =
                    item.options && item.options.allowNew !== undefined
                        ? item.options.allowNew
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                        ? editorConfig.lookup.allowNew
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                        ? fieldConfig.lookup.allowNew
                        : false;

                var dataSource = [];

                if (!isRemote) {
                    if (lookupClientValues) dataSource = lookupClientValues;

                    if (prepareLookups instanceof Array && lookupServerName) {
                        var found = prepareLookups.find((l) => l.name === lookupServerName);

                        if (found && found.values instanceof Array) {
                            found = JSON.parse(stringify(found));
                            for (let i = 0; i < found.values.length; i++) {
                                var newValue = found.values[i];
                                if (newValue.code) {
                                    var oldValue = dataSource.find((d) => d.code === newValue.code);
                                    if (oldValue) {
                                        Object.keys(newValue).forEach((k) => {
                                            if (oldValue[k] === undefined) oldValue[k] = newValue[k];
                                        });
                                    } else dataSource.push(newValue);
                                } else dataSource.push(newValue);
                            }
                        }
                    } else {
                        if (formData) dataSource.push(formData[item.dataField]);
                    }
                    if (searchConditions)
                        dataSource = dataSource.filter((value) =>
                            AntCondition.isValid(value, {
                                when: { ...searchConditions }
                            })
                        );
                }

                var showClearButton =
                    !item.disabled &&
                    (item.showClearButton !== undefined
                        ? item.showClearButton
                        : props.defaultSelectShowClearButton !== undefined
                        ? props.defaultSelectShowClearButton
                        : true);
                var showDropDownButton = allowNew
                    ? false
                    : !item.disabled && (item.showDropDownButton !== undefined ? item.showDropDownButton : true);

                if (dataSource instanceof Array)
                    dataSource = dataSource.map((d) => {
                        let vName = AntCondition.getValue(formData, d.name);
                        d.name = AntLocalization.translateText(vName);
                    });

                return (
                    <SelectBox
                        ref={itemRef}
                        items={dataSource}
                        acceptCustomValue={allowNew}
                        placeholder={!Boolean(item.label?.visible) && item.placeholder ? item.placeholder : '...'}
                        showClearButton={showClearButton}
                        showDropDownButton={showDropDownButton}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        noDataText={AntLocalization.translateText({ vi: 'Không có dữ liệu !', en: 'Have no data !', fr: 'Aucune donnée !', es: '¡Sin datos!', id: 'Tidak ada data!', ja: 'データがありません！', zh: '没有数据！', ko: '데이터 없음!', hi: 'कोई डेटा नहीं!', ar: 'لا توجد بيانات!' })}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </SelectBox>
                );
            }

            if (item.editorType == 'antSelectBox') {
                var dataSource = [];

                var url =
                    item.options && item.options.url
                        ? item.options.url
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                        ? editorConfig.lookup.url
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                        ? fieldConfig.lookup.url
                        : null;

                var keyField =
                    item.options && item.options.keyField
                        ? item.options.keyField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                        ? editorConfig.lookup.keyField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                        ? fieldConfig.lookup.keyField
                        : 'code';

                var valueField =
                    item.options && item.options.valueField
                        ? item.options.valueField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                        ? editorConfig.lookup.valueField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                        ? fieldConfig.lookup.valueField
                        : 'code';

                var displayField =
                    item.options && item.options.displayField
                        ? item.options.displayField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                        ? editorConfig.lookup.displayField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                        ? fieldConfig.lookup.displayField
                        : 'name';

                var formDisplayField =
                    item.options && item.options.formDisplayField
                        ? item.options.formDisplayField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.formDisplayField
                        ? editorConfig.lookup.formDisplayField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.formDisplayField
                        ? fieldConfig.lookup.formDisplayField
                        : null;

                if (!formDisplayField) {
                    var strField = String(item.dataField).replace('_code', '_name');
                    if (strField !== item.dataField) formDisplayField = strField;
                    else if (item.dataField === 'code') formDisplayField = 'code';
                }

                // if (!formDisplayField) {
                //     formDisplayField =
                //         item.options && item.options.displayField
                //             ? item.options.displayField
                //             : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                //             ? editorConfig.lookup.displayField
                //             : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                //             ? fieldConfig.lookup.displayField
                //             : item.displayField;
                // }

                var tableName =
                    item.options && item.options.table
                        ? item.options.table
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                        ? editorConfig.lookup.table
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                        ? fieldConfig.lookup.table
                        : null;

                var height =
                    item.options && item.options.height !== undefined
                        ? item.options.height
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                        ? editorConfig.lookup.height
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                        ? fieldConfig.lookup.height
                        : null;

                var width =
                    item.options && item.options.width !== undefined
                        ? item.options.width
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                        ? editorConfig.lookup.width
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                        ? fieldConfig.lookup.width
                        : undefined;

                var mappings =
                    item.options && item.options.mapping instanceof Array
                        ? item.options.mapping
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mapping instanceof Array
                        ? editorConfig.lookup.mapping
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mapping instanceof Array
                        ? fieldConfig.lookup.mapping
                        : [];

                var mappingWhen =
                    item.options && item.options.mappingWhen instanceof Array
                        ? item.options.mappingWhen
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhen instanceof Array
                        ? editorConfig.lookup.mappingWhen
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhen instanceof Array
                        ? fieldConfig.lookup.mappingWhen
                        : null;

                var mappingWhenType =
                    item.options && item.options.mappingWhenType instanceof Array
                        ? item.options.mappingWhenType
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhenType instanceof Array
                        ? editorConfig.lookup.mappingWhenType
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhenType instanceof Array
                        ? fieldConfig.lookup.mappingWhenType
                        : null;

                var parentFields = item.options && item.options.parentFields instanceof Array ? item.options.parentFields : undefined;

                var refreshOnOpened =
                    parentFields !== undefined
                        ? true
                        : item.options && item.options.refreshOnOpened !== undefined
                        ? item.options.refreshOnOpened
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                        ? editorConfig.lookup.refreshOnOpened
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                        ? fieldConfig.lookup.refreshOnOpened
                        : undefined;

                var searchConditions =
                    item.options && item.options.searchConditions !== undefined
                        ? item.options.searchConditions
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                        ? editorConfig.lookup.searchConditions
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                        ? fieldConfig.lookup.searchConditions
                        : null;

                var lookupClientValues =
                    item.options && item.options.values !== undefined
                        ? item.options.values
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                        ? editorConfig.lookup.values
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                        ? fieldConfig.lookup.values
                        : null;

                lookupClientValues =
                    lookupClientValues instanceof Array && lookupClientValues.length > 0
                        ? lookupClientValues.map((o) => {
                              if (typeof o === 'string') return { code: o };
                              return o;
                          })
                        : typeof lookupClientValues === 'object' && lookupClientValues !== null
                        ? [lookupClientValues]
                        : typeof lookupClientValues === 'string' && lookupClientValues !== null
                        ? [{ code: lookupClientValues }]
                        : [];

                lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

                if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                    if (item.options && item.options.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = item.options.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                    if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                }

                var lookupServerName =
                    item.options && item.options.lookupServerName !== undefined
                        ? item.options.lookupServerName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                        ? editorConfig.lookup.serverName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                        ? fieldConfig.lookup.serverName
                        : item.dataField;

                var lookupClientName =
                    item.options && item.options.lookupClientName !== undefined
                        ? item.options.lookupClientName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                        ? editorConfig.lookup.clientName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                        ? fieldConfig.lookup.clientName
                        : item.dataField;

                var isRemote =
                    item.options && item.options.isRemote !== undefined
                        ? item.options.isRemote
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                        ? fieldConfig.lookup.isRemote
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                        ? editorConfig.lookup.isRemote
                        : Boolean(url);

                var remotePaging =
                    item.options && item.options.remotePaging !== undefined
                        ? item.options.remotePaging
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.remotePaging !== undefined
                        ? fieldConfig.lookup.remotePaging
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.remotePaging !== undefined
                        ? editorConfig.lookup.remotePaging
                        : true;

                if (!isRemote) {
                    if (lookupClientValues) dataSource = JSON.parse(stringify(lookupClientValues));

                    if (prepareLookups instanceof Array && lookupServerName) {
                        let found = prepareLookups.find((l) => l.name === lookupServerName);

                        if (found && found.values instanceof Array) {
                            found = JSON.parse(stringify(found));
                            let remoteDS = found.values
                                .filter((v) => Boolean(v))
                                .map((v) => {
                                    if (typeof v === 'object') return { ...v };
                                    else return { code: v };
                                });

                            for (let i = 0; i < remoteDS.length; i++) {
                                let remoteValue = remoteDS[i];
                                if (typeof remoteValue === 'object' && remoteValue && remoteValue.visible === false) continue;

                                if (remoteValue) {
                                    if (remoteValue.code) {
                                        let clientValue = dataSource.find((d) => d.code === remoteValue.code);
                                        if (clientValue) {
                                            Object.keys(remoteValue).forEach((k) => {
                                                if (clientValue[k] === undefined) clientValue[k] = remoteValue[k];
                                            });
                                        } else dataSource.push(remoteValue);
                                    } else {
                                        dataSource.push(remoteValue);
                                    }
                                }
                            }
                        }
                    }

                    if (lookupClientValues instanceof Array && lookupClientValues.length > 0) {
                        dataSource = dataSource.filter((v) => lookupClientValues.some((d) => d.code === v.code && v.visible !== false));
                    }

                    dataSource = dataSource
                        .map((v) => {
                            return { ...v, visible: AntCondition.isVisible(formData, v) };
                        })
                        .filter((v) => v.visible);

                    if (searchConditions) {
                        dataSource = dataSource.filter((value) =>
                            AntCondition.isValid(value, {
                                when: { ...searchConditions }
                            })
                        );
                    }
                }

                if (!height) height = 200;

                var isRequired = false;
                if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

                var allowNew =
                    item.options && item.options.allowNew !== undefined
                        ? item.options.allowNew
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                        ? editorConfig.lookup.allowNew
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                        ? fieldConfig.lookup.allowNew
                        : false;

                var showClearButton =
                    // !item.disabled &&
                    item.options && item.options.showClearButton !== undefined
                        ? item.options.showClearButton
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                        ? editorConfig.lookup.showClearButton
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                        ? fieldConfig.lookup.showClearButton
                        : props.defaultSelectShowClearButton !== undefined
                        ? props.defaultSelectShowClearButton
                        : !isRequired;

                var showDropDownButton =
                    allowNew || showClearButton
                        ? false
                        : !item.disabled &&
                          (item.options && item.options.showDropDownButton !== undefined
                              ? item.options.showDropDownButton
                              : editorConfig && editorConfig.lookup && editorConfig.lookup.showDropDownButton !== undefined
                              ? editorConfig.lookup.showDropDownButton
                              : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showDropDownButton !== undefined
                              ? fieldConfig.lookup.showDropDownButton
                              : true);

                var ordering =
                    item.options && item.options.ordering !== undefined
                        ? item.options.ordering
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.ordering
                        ? editorConfig.lookup.ordering
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.ordering
                        ? fieldConfig.lookup.ordering
                        : null;

                return (
                    <AntSelectBox
                        ref={itemRef}
                        formRef={form}
                        dataField={item.dataField}
                        name={tableName + '_' + item.name}
                        formDisplayField={formDisplayField}
                        API={props.API}
                        url={url}
                        isRemote={isRemote}
                        remotePaging={remotePaging}
                        refreshOnOpened={refreshOnOpened}
                        lookupName={lookupServerName}
                        searchConditions={searchConditions}
                        defaultValue={formData ? formData[item.dataField] : null}
                        parentFields={parentFields}
                        isSearching={item.options && item.options.isSearching !== undefined ? item.options.isSearching : true}
                        acceptCustomValue={allowNew}
                        showClearButton={showClearButton}
                        showDropDownButton={showDropDownButton}
                        height={height}
                        width={width}
                        ordering={ordering}
                        options={{
                            ...item.options,
                            table: tableName,
                            dataSource: dataSource,
                            keyExpr: keyField,
                            valueExpr: valueField,
                            displayExpr: displayField,
                            // placeholder: item.placeholder,
                            noDataText: AntLocalization.translateText({ vi: 'Không có dữ liệu !', en: 'Have no data !', fr: 'Aucune donnée !', es: '¡Sin datos!', id: 'Tidak ada data!', ja: 'データがありません！', zh: '没有数据！', ko: '데이터 없음!', hi: 'कोई डेटा नहीं!', ar: 'لا توجد بيانات!' }),
                            stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                            className: item.options && item.options.className ? item.options.className : undefined
                        }}
                        searchEnabled={Boolean(isRemote)}
                        focusStateEnabled={!Boolean(item.disabled)}
                        validationRules={item.disabled ? [] : item.validationRules}
                        getQueryFields={() => {
                            return mappings.map((m) => m.from);
                        }}
                        onValueChanged={(e) => {
                            var obj = { [item.dataField]: e.value };
                            if (formDisplayField && displayField && formDisplayField !== item.dataField) {
                                obj[formDisplayField] = e.value !== null && e.value !== undefined && e.rowData ? e.rowData[displayField] : null;
                            }

                            var isMapping = true;
                            if (mappingWhen && typeof mappingWhen === 'object') {
                                isMapping = AntCondition.isValid(formData, {
                                    when: mappingWhen,
                                    whenType: mappingWhenType
                                });
                            }

                            if (isMapping) {
                                for (let i = 0; i < mappings.length; i++) {
                                    const m = mappings[i];

                                    if (m.when && typeof m.when === 'object') {
                                        var mValid = AntCondition.isValid(formData, {
                                            when: m.when,
                                            whenType: m.whenType
                                        });
                                        if (!mValid) continue;
                                    }

                                    var sourceField = m.from;
                                    var destField = m.to;
                                    if (sourceField && destField) {
                                        if (
                                            e.rowData === null ||
                                            e.rowData === undefined ||
                                            e.rowData[sourceField] === null ||
                                            e.rowData[sourceField] === undefined
                                        ) {
                                            if (formData[destField] !== null && formData[destField] !== undefined) obj[destField] = null;
                                        } else {
                                            if (formData[destField] !== e.rowData[sourceField]) obj[destField] = e.rowData[sourceField];
                                        }
                                    }

                                    var setField = m.set;
                                    var fieldValue = m.value;
                                    if (setField && fieldValue !== undefined) {
                                        obj[setField] = fieldValue;
                                    }
                                }
                            }

                            var keys = Object.keys(obj);
                            for (let i = 0; i < keys.length; i++) {
                                const k = keys[i];
                                args.component.itemOption(k, 'value', obj[k]);
                            }

                            if (keys.length > 0) onFieldDataChanged(obj);
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    />
                );
            }

            if (item.editorType == 'antTagBox' || item.dataType === 'Array') {
                var dataSource = [];

                var url =
                    item.options && item.options.url
                        ? item.options.url
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                        ? editorConfig.lookup.url
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                        ? fieldConfig.lookup.url
                        : null;

                var keyField =
                    item.options && item.options.keyField
                        ? item.options.keyField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                        ? editorConfig.lookup.keyField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                        ? fieldConfig.lookup.keyField
                        : 'code';

                var valueField =
                    item.options && item.options.valueField
                        ? item.options.valueField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                        ? editorConfig.lookup.valueField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                        ? fieldConfig.lookup.valueField
                        : 'code';

                var displayField =
                    item.options && item.options.displayField
                        ? item.options.displayField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                        ? editorConfig.lookup.displayField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                        ? fieldConfig.lookup.displayField
                        : 'name';

                var tableName =
                    item.options && item.options.table
                        ? item.options.table
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                        ? editorConfig.lookup.table
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                        ? fieldConfig.lookup.table
                        : null;

                var height =
                    item.options && item.options.height !== undefined
                        ? item.options.height
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                        ? editorConfig.lookup.height
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                        ? fieldConfig.lookup.height
                        : null;
                if (!height) height = 200;

                var width =
                    item.options && item.options.width !== undefined
                        ? item.options.width
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                        ? editorConfig.lookup.width
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                        ? fieldConfig.lookup.width
                        : undefined;

                var parentFields = item.options && item.options.parentFields instanceof Array ? item.options.parentFields : undefined;

                var refreshOnOpened =
                    parentFields !== undefined
                        ? true
                        : item.options && item.options.refreshOnOpened !== undefined
                        ? item.options.refreshOnOpened
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                        ? editorConfig.lookup.refreshOnOpened
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                        ? fieldConfig.lookup.refreshOnOpened
                        : undefined;

                var searchConditions =
                    item.options && item.options.searchConditions !== undefined
                        ? item.options.searchConditions
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                        ? editorConfig.lookup.searchConditions
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                        ? fieldConfig.lookup.searchConditions
                        : null;

                var lookupClientValues =
                    item.options && item.options.values !== undefined
                        ? item.options.values
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                        ? editorConfig.lookup.values
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                        ? fieldConfig.lookup.values
                        : null;

                lookupClientValues =
                    lookupClientValues instanceof Array && lookupClientValues.length > 0
                        ? lookupClientValues.map((o) => {
                              if (typeof o === 'string') return { code: o };
                              return o;
                          })
                        : typeof lookupClientValues === 'object' && lookupClientValues !== null
                        ? [lookupClientValues]
                        : typeof lookupClientValues === 'string' && lookupClientValues !== null
                        ? [{ code: lookupClientValues }]
                        : [];

                lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

                if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                    if (item.options && item.options.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = item.options.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                    if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                }

                var lookupServerName =
                    item.options && item.options.lookupServerName !== undefined
                        ? item.options.lookupServerName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                        ? editorConfig.lookup.serverName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                        ? fieldConfig.lookup.serverName
                        : item.dataField;

                var lookupClientName =
                    item.options && item.options.lookupClientName !== undefined
                        ? item.options.lookupClientName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                        ? editorConfig.lookup.clientName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                        ? fieldConfig.lookup.clientName
                        : item.dataField;

                var isRemote =
                    item.options && item.options.isRemote !== undefined
                        ? item.options.isRemote
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                        ? editorConfig.lookup.isRemote
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                        ? fieldConfig.lookup.isRemote
                        : Boolean(url);

                var remotePaging =
                    item.options && item.options.remotePaging !== undefined
                        ? item.options.remotePaging
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.remotePaging !== undefined
                        ? editorConfig.lookup.remotePaging
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.remotePaging !== undefined
                        ? fieldConfig.lookup.remotePaging
                        : true;

                if (!isRemote) {
                    if (lookupClientValues) dataSource = lookupClientValues;

                    if (prepareLookups instanceof Array && lookupServerName) {
                        var found = prepareLookups.find((l) => l.name === lookupServerName);

                        if (found && found.values instanceof Array) {
                            found = JSON.parse(stringify(found));
                            var remoteDS = found.values
                                .filter((v) => Boolean(v))
                                .map((v) => {
                                    if (typeof v === 'object') return { ...v };
                                    else return { code: v };
                                });

                            for (let i = 0; i < remoteDS.length; i++) {
                                var remoteValue = remoteDS[i];
                                if (remoteValue) {
                                    if (remoteValue.code) {
                                        var clientValue = dataSource.find((d) => d.code === remoteValue.code);
                                        if (clientValue) {
                                            Object.keys(clientValue).forEach((k) => {
                                                if (remoteValue[k] === undefined) remoteValue[k] = clientValue[k];
                                            });
                                        } else dataSource.push(remoteValue);
                                    } else {
                                        dataSource.push(remoteValue);
                                    }
                                }
                            }
                        }
                    }

                    if (searchConditions)
                        dataSource = dataSource.filter((value) =>
                            AntCondition.isValid(value, {
                                when: { ...searchConditions }
                            })
                        );

                    searchBar = false;
                }

                var isRequired = false;
                if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

                // var allowNew = false;
                var allowNew =
                    item.options && item.options.allowNew !== undefined
                        ? item.options.allowNew
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                        ? editorConfig.lookup.allowNew
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                        ? fieldConfig.lookup.allowNew
                        : false;

                var showClearButton =
                    // !item.disabled &&
                    item.options && item.options.showClearButton !== undefined
                        ? item.options.showClearButton
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                        ? editorConfig.lookup.showClearButton
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                        ? fieldConfig.lookup.showClearButton
                        : !isRequired;

                var ordering =
                    item.options && item.options.ordering !== undefined
                        ? item.options.ordering
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.ordering
                        ? editorConfig.lookup.ordering
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.ordering
                        ? fieldConfig.lookup.ordering
                        : null;

                if (formData && formData.edit && formData.edit.editable_fields && formData.edit.editable_fields instanceof Array) {
                    var found = formData.edit.editable_fields.find((f) => typeof f === 'object' && f !== null && f.field === item.dataField);

                    if (found && found.disableValues instanceof Array) {
                        dataSource.forEach((v) => {
                            if (found.disableValues.includes(v.code)) {
                                v.disabled = true;
                                showClearButton = false;
                            }
                        });
                    }
                }

                return (
                    <AntTagBox
                        ref={itemRef}
                        formRef={form}
                        placeholder={!Boolean(item.label?.visible) && item.placeholder ? item.placeholder : '...'}
                        dataField={item.dataField}
                        name={tableName + '_' + item.name}
                        formDisplayField={formDisplayField}
                        API={props.API}
                        url={url}
                        isRemote={isRemote}
                        remotePaging={remotePaging}
                        refreshOnOpened={refreshOnOpened}
                        lookupName={lookupServerName}
                        searchConditions={searchConditions}
                        defaultValue={formData ? formData[item.dataField] : null}
                        parentFields={parentFields}
                        acceptCustomValue={allowNew}
                        showClearButton={showClearButton}
                        height={height}
                        width={width}
                        ordering={ordering}
                        options={{
                            ...item.options,
                            table: tableName,
                            dataSource: dataSource,
                            keyExpr: keyField,
                            valueExpr: valueField,
                            displayExpr: displayField,
                            // placeholder: item.placeholder,
                            noDataText: AntLocalization.translateText({ vi: 'Không có dữ liệu !', en: 'Have no data !', fr: 'Aucune donnée !', es: '¡Sin datos!', id: 'Tidak ada data!', ja: 'データがありません！', zh: '没有数据！', ko: '데이터 없음!', hi: 'कोई डेटा नहीं!', ar: 'لا توجد بيانات!' }),
                            stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                            className: item.options && item.options.className ? item.options.className : undefined
                        }}
                        focusStateEnabled={!Boolean(item.disabled)}
                        validationRules={item.disabled ? [] : item.validationRules}
                        // getQueryFields={() => {
                        //     return mappings.map((m) => m.from);
                        // }}
                        onValueChanged={(e) => {
                            var value = e.value instanceof Array && e.value.length <= 0 ? null : e.value;

                            onFieldDataChanged({
                                [item.dataField]: value
                            });
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    />
                );
            }

            if (item.editorType == 'antCustomPopup') {
                var PickerRegistry = (typeof window !== 'undefined' && window.__AntPickerRegistry) || {};
                var pickerName = (item.options && item.options.component) || (editorConfig && editorConfig.component) || null;
                var PickerComp = pickerName && PickerRegistry[pickerName];
                if (!PickerComp) {
                    console.warn('AntBaseForm: antCustomPopup missing component for', item.dataField, pickerName);
                    return null;
                }
                return (
                    <PickerComp
                        dataField={item.dataField}
                        value={formData ? formData[item.dataField] : undefined}
                        formData={formData}
                        session={props.session}
                        options={item.options || {}}
                        editorConfig={editorConfig}
                        fieldConfig={fieldConfig}
                        disabled={item.disabled}
                        onValueChanged={(patch) => {
                            if (!patch || typeof patch !== 'object') return;
                            onFieldDataChanged(patch);
                        }}
                    />
                );
            }

            if (item.editorType == 'antDropDownGrid') {
                var dataSource = [];

                var options = { ...fieldConfig?.lookup, ...editorConfig?.lookup, ...item?.options };

                var url =
                    item.options && item.options.url
                        ? item.options.url
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                        ? editorConfig.lookup.url
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                        ? fieldConfig.lookup.url
                        : null;

                var keyField =
                    item.options && item.options.keyField
                        ? item.options.keyField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                        ? editorConfig.lookup.keyField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                        ? fieldConfig.lookup.keyField
                        : null;

                var valueField =
                    item.options && item.options.valueField
                        ? item.options.valueField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                        ? editorConfig.lookup.valueField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                        ? fieldConfig.lookup.valueField
                        : 'code';

                var displayField =
                    item.options && item.options.displayField
                        ? item.options.displayField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                        ? editorConfig.lookup.displayField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                        ? fieldConfig.lookup.displayField
                        : 'name';

                var formDisplayField =
                    item.options && item.options.formDisplayField
                        ? item.options.formDisplayField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.formDisplayField
                        ? editorConfig.lookup.formDisplayField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.formDisplayField
                        ? fieldConfig.lookup.formDisplayField
                        : null;

                if (!formDisplayField) {
                    var strField = String(item.dataField).replace('_code', '_name');
                    if (strField !== item.dataField) formDisplayField = strField;
                    else if (item.dataField === 'code') formDisplayField = 'code';
                }

                // if (!formDisplayField) {
                //     formDisplayField =
                //         item.options && item.options.displayField
                //             ? item.options.displayField
                //             : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                //             ? editorConfig.lookup.displayField
                //             : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                //             ? fieldConfig.lookup.displayField
                //             : item.displayField;
                // }

                var moduleName =
                    item.options && item.options.module
                        ? item.options.module
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.module
                        ? editorConfig.lookup.module
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.module
                        ? fieldConfig.lookup.module
                        : null;

                var tableName =
                    item.options && item.options.table
                        ? item.options.table
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                        ? editorConfig.lookup.table
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                        ? fieldConfig.lookup.table
                        : null;

                var searchBar =
                    item.options && item.options.searchBar !== undefined
                        ? item.options.searchBar
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchBar
                        ? editorConfig.lookup.searchBar
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchBar
                        ? fieldConfig.lookup.searchBar
                        : null;

                var columns =
                    item.options && item.options.columns
                        ? item.options.columns
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.columns
                        ? editorConfig.lookup.columns
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.columns
                        ? fieldConfig.lookup.columns
                        : null;

                var height =
                    item.options && item.options.height !== undefined
                        ? item.options.height
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                        ? editorConfig.lookup.height
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                        ? fieldConfig.lookup.height
                        : null;

                if (!height) {
                    if (String(item.dataField).endsWith('code')) height = 250;
                    else if (
                        (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) ||
                        (item.options && item.options.values instanceof Array)
                    )
                        height = 200;
                    else height = 250;
                }

                var width =
                    item.options && item.options.width !== undefined
                        ? item.options.width
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                        ? editorConfig.lookup.width
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                        ? fieldConfig.lookup.width
                        : undefined;

                var actionItems =
                    item.options && item.options.actionItems instanceof Array
                        ? item.options.actionItems
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.actionItems instanceof Array
                        ? editorConfig.lookup.actionItems
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.actionItems instanceof Array
                        ? fieldConfig.lookup.actionItems
                        : undefined;

                var mappings =
                    item.options && item.options.mapping instanceof Array
                        ? item.options.mapping
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mapping instanceof Array
                        ? editorConfig.lookup.mapping
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mapping instanceof Array
                        ? fieldConfig.lookup.mapping
                        : [];

                var mappingWhen =
                    item.options && item.options.mappingWhen instanceof Array
                        ? item.options.mappingWhen
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhen instanceof Array
                        ? editorConfig.lookup.mappingWhen
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhen instanceof Array
                        ? fieldConfig.lookup.mappingWhen
                        : null;

                var mappingWhenType =
                    item.options && item.options.mappingWhenType instanceof Array
                        ? item.options.mappingWhenType
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhenType instanceof Array
                        ? editorConfig.lookup.mappingWhenType
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhenType instanceof Array
                        ? fieldConfig.lookup.mappingWhenType
                        : null;

                var parentFields = item.options && item.options.parentFields instanceof Array ? item.options.parentFields : undefined;

                var refreshOnOpened =
                    parentFields !== undefined
                        ? true
                        : item.options && item.options.refreshOnOpened !== undefined
                        ? item.options.refreshOnOpened
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                        ? editorConfig.lookup.refreshOnOpened
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                        ? fieldConfig.lookup.refreshOnOpened
                        : undefined;

                var searchConditions =
                    item.options && item.options.searchConditions !== undefined
                        ? item.options.searchConditions
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                        ? editorConfig.lookup.searchConditions
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                        ? fieldConfig.lookup.searchConditions
                        : null;

                var lookupClientValues =
                    item.options && item.options.values !== undefined
                        ? item.options.values
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                        ? editorConfig.lookup.values
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                        ? fieldConfig.lookup.values
                        : null;

                lookupClientValues =
                    lookupClientValues instanceof Array && lookupClientValues.length > 0
                        ? lookupClientValues.map((o) => {
                              if (typeof o === 'string') return { code: o };
                              return o;
                          })
                        : typeof lookupClientValues === 'object' && lookupClientValues !== null
                        ? [lookupClientValues]
                        : typeof lookupClientValues === 'string' && lookupClientValues !== null
                        ? [{ code: lookupClientValues }]
                        : [];

                lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

                if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                    if (item.options && item.options.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = item.options.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                    if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                }
                var lookupServerName =
                    item.options && item.options.lookupServerName !== undefined
                        ? item.options.lookupServerName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                        ? editorConfig.lookup.serverName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                        ? fieldConfig.lookup.serverName
                        : item.dataField;

                var lookupClientName =
                    item.options && item.options.lookupClientName !== undefined
                        ? item.options.lookupClientName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                        ? editorConfig.lookup.clientName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                        ? fieldConfig.lookup.clientName
                        : item.dataField;

                var isRemote =
                    item.options && item.options.isRemote !== undefined
                        ? item.options.isRemote
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                        ? editorConfig.lookup.isRemote
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                        ? fieldConfig.lookup.isRemote
                        : Boolean(url);

                var remotePaging =
                    item.options && item.options.remotePaging !== undefined
                        ? item.options.remotePaging
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.remotePaging !== undefined
                        ? editorConfig.lookup.remotePaging
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.remotePaging !== undefined
                        ? fieldConfig.lookup.remotePaging
                        : true;

                if (!isRemote) {
                    if (lookupClientValues) dataSource = lookupClientValues;

                    if (prepareLookups instanceof Array && lookupServerName) {
                        var found = prepareLookups.find((l) => l.name === lookupServerName);

                        if (found && found.values instanceof Array) {
                            found = JSON.parse(stringify(found));
                            for (let i = 0; i < found.values.length; i++) {
                                var newValue = found.values[i];
                                if (newValue.code) {
                                    var oldValue = dataSource.find((d) => d.code === newValue.code);
                                    if (oldValue) {
                                        Object.keys(newValue).forEach((k) => {
                                            if (oldValue[k] === undefined) oldValue[k] = newValue[k];
                                        });
                                    } else dataSource.push(newValue);
                                } else dataSource.push(newValue);
                            }
                        }
                    }
                    if (searchConditions)
                        dataSource = dataSource.filter((value) =>
                            AntCondition.isValid(value, {
                                when: { ...searchConditions }
                            })
                        );

                    searchBar = false;
                    if (!columns)
                        columns = [
                            {
                                dataField: 'name'
                            }
                        ];
                } else {
                    if (!columns)
                        columns = [
                            {
                                dataField: item.dataField
                            }
                        ];
                }

                var isRequired = false;
                if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

                var allowNew =
                    item.options && item.options.allowNew !== undefined
                        ? item.options.allowNew
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                        ? editorConfig.lookup.allowNew
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                        ? fieldConfig.lookup.allowNew
                        : false;

                var showClearButton =
                    // !item.disabled &&
                    item.options && item.options.showClearButton !== undefined
                        ? item.options.showClearButton
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                        ? editorConfig.lookup.showClearButton
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                        ? fieldConfig.lookup.showClearButton
                        : !isRequired;

                var showDropDownButton = showClearButton
                    ? false
                    : !item.disabled &&
                      (item.options && item.options.showDropDownButton !== undefined
                          ? item.options.showDropDownButton
                          : editorConfig && editorConfig.lookup && editorConfig.lookup.showDropDownButton !== undefined
                          ? editorConfig.lookup.showDropDownButton
                          : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showDropDownButton !== undefined
                          ? fieldConfig.lookup.showDropDownButton
                          : true);

                var showLookupButton =
                    item.options && item.options.showLookupButton !== undefined
                        ? item.options.showLookupButton
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.showLookupButton !== undefined
                        ? editorConfig.lookup.showLookupButton
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showLookupButton !== undefined
                        ? fieldConfig.lookup.showLookupButton
                        : false;

                var showActions =
                    item.options && item.options.showActions !== undefined
                        ? item.options.showActions
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.showActions !== undefined
                        ? editorConfig.lookup.showActions
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showActions !== undefined
                        ? fieldConfig.lookup.showActions
                        : true;

                var groupByField =
                    item.options && item.options.groupByField !== undefined
                        ? item.options.groupByField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.groupByField
                        ? editorConfig.lookup.groupByField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.groupByField
                        ? fieldConfig.lookup.groupByField
                        : null;

                var ordering =
                    item.options && item.options.ordering !== undefined
                        ? item.options.ordering
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.ordering
                        ? editorConfig.lookup.ordering
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.ordering
                        ? fieldConfig.lookup.ordering
                        : null;

                var searchCategories1 =
                    item.options && item.options.searchCategories1 !== undefined
                        ? item.options.searchCategories1
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchCategories1
                        ? editorConfig.lookup.searchCategories1
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchCategories1
                        ? fieldConfig.lookup.searchCategories1
                        : null;
                var searchCategories2 =
                    item.options && item.options.searchCategories2 !== undefined
                        ? item.options.searchCategories2
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchCategories2
                        ? editorConfig.lookup.searchCategories2
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchCategories2
                        ? fieldConfig.lookup.searchCategories2
                        : null;
                var searchCategories3 =
                    item.options && item.options.searchCategories3 !== undefined
                        ? item.options.searchCategories3
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchCategories3
                        ? editorConfig.lookup.searchCategories3
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchCategories3
                        ? fieldConfig.lookup.searchCategories3
                        : null;
                return (
                    <AntDropDownGrid
                        ref={itemRef}
                        formRef={form}
                        // Khoá cấu hình lưới trong ô chọn (độ rộng, sắp xếp, ẩn hiện cột, kích thước popup): tên editor.
                        settingsName={editorConfig && editorConfig.name ? editorConfig.name : undefined}
                        dataField={item.dataField}
                        name={tableName + '_' + item.name}
                        formDisplayField={formDisplayField}
                        groupByField={groupByField}
                        API={moduleName && tableName ? new AntAPI(moduleName, tableName) : props.API}
                        url={url}
                        isRemote={isRemote}
                        remotePaging={remotePaging}
                        refreshOnOpened={refreshOnOpened}
                        lookupName={lookupServerName}
                        searchConditions={searchConditions}
                        value={formData ? formData[item.dataField] : null}
                        parentFields={parentFields}
                        isSearching={item.options && item.options.isSearching !== undefined ? item.options.isSearching : true}
                        acceptCustomValue={allowNew}
                        showClearButton={showClearButton}
                        showDropDownButton={showDropDownButton}
                        showLookupButton={showLookupButton}
                        editorOptions={{
                            stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                            className: item.options && item.options.className ? item.options.className : undefined
                        }}
                        dropDownOptions={options?.dropDownOptions}
                        height={item.dataField === 'code' ? 380 : height}
                        width={width}
                        ordering={ordering}
                        gridOptions={{
                            ...options,
                            module: moduleName,
                            table: tableName,
                            dataSource: dataSource,
                            keyExpr: keyField,
                            valueExpr: valueField,
                            displayExpr: displayField,
                            columns: columns,
                            searchBar: searchBar,
                            showActions: showActions,
                            actionItems: actionItems,
                            searchCategories1: searchCategories1,
                            searchCategories2: searchCategories2,
                            searchCategories3: searchCategories3,
                            placeholder: item.placeholder
                        }}
                        focusStateEnabled={!Boolean(item.disabled)}
                        validationRules={item.disabled ? [] : item.validationRules}
                        getQueryFields={() => {
                            return mappings.map((m) => m.from);
                        }}
                        onValueChanged={(e) => {
                            var obj = { [item.dataField]: e.value };
                            if (formDisplayField && displayField && formDisplayField !== item.dataField) {
                                obj[formDisplayField] = e.value !== null && e.value !== undefined && e.rowData ? e.rowData[displayField] : null;
                            }

                            var isMapping = true;
                            if (mappingWhen && typeof mappingWhen === 'object') {
                                isMapping = AntCondition.isValid(formData, {
                                    when: mappingWhen,
                                    whenType: mappingWhenType
                                });
                            }

                            if (isMapping) {
                                for (let i = 0; i < mappings.length; i++) {
                                    const m = mappings[i];

                                    if (m.when && typeof m.when === 'object') {
                                        var mValid = AntCondition.isValid(formData, {
                                            when: m.when,
                                            whenType: m.whenType
                                        });
                                        if (!mValid) continue;
                                    }
                                    var sourceField = m.from;
                                    var destField = m.to;
                                    if (sourceField && destField) {
                                        if (
                                            e.rowData === null ||
                                            e.rowData === undefined ||
                                            e.rowData[sourceField] === null ||
                                            e.rowData[sourceField] === undefined
                                        ) {
                                            if (formData[destField] !== null && formData[destField] !== undefined) obj[destField] = null;
                                        } else {
                                            if (formData[destField] !== e.rowData[sourceField]) obj[destField] = e.rowData[sourceField];
                                        }
                                    }

                                    var setField = m.set;
                                    var fieldValue = m.value;
                                    if (setField && fieldValue !== undefined) {
                                        obj[setField] = fieldValue;
                                    }
                                }
                            }

                            var keys = Object.keys(obj);
                            for (let i = 0; i < keys.length; i++) {
                                const k = keys[i];
                                args.component.itemOption(k, 'value', obj[k]);
                            }

                            if (keys.length > 0) onFieldDataChanged(obj);
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    />
                );
            }

            if (item.editorType == 'antDropDownTree') {
                var dataSource = [];

                var url =
                    item.options && item.options.url
                        ? item.options.url
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                        ? editorConfig.lookup.url
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                        ? fieldConfig.lookup.url
                        : null;

                var keyField =
                    item.options && item.options.keyField
                        ? item.options.keyField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                        ? editorConfig.lookup.keyField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                        ? fieldConfig.lookup.keyField
                        : null;
                var valueField =
                    item.options && item.options.valueField
                        ? item.options.valueField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                        ? editorConfig.lookup.valueField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                        ? fieldConfig.lookup.valueField
                        : 'code';

                var displayField =
                    item.options && item.options.displayField
                        ? item.options.displayField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                        ? editorConfig.lookup.displayField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                        ? fieldConfig.lookup.displayField
                        : 'name';

                var formDisplayField =
                    item.options && item.options.formDisplayField
                        ? item.options.formDisplayField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.formDisplayField
                        ? editorConfig.lookup.formDisplayField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.formDisplayField
                        ? fieldConfig.lookup.formDisplayField
                        : null;

                if (!formDisplayField) {
                    var strField = String(item.dataField).replace('_code', '_name');
                    if (strField !== item.dataField) formDisplayField = strField;
                    else if (item.dataField === 'code') formDisplayField = 'code';
                }

                // if (!formDisplayField) {
                //     formDisplayField =
                //         item.options && item.options.displayField
                //             ? item.options.displayField
                //             : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                //             ? editorConfig.lookup.displayField
                //             : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                //             ? fieldConfig.lookup.displayField
                //             : item.displayField;
                // }

                var parentField =
                    item.options && item.options.parentField
                        ? item.options.parentField
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.parentField
                        ? editorConfig.lookup.parentField
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.parentField
                        ? fieldConfig.lookup.parentField
                        : null;

                var moduleName =
                    item.options && item.options.module
                        ? item.options.module
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.module
                        ? editorConfig.lookup.module
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.module
                        ? fieldConfig.lookup.module
                        : null;

                var tableName =
                    item.options && item.options.table
                        ? item.options.table
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                        ? editorConfig.lookup.table
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                        ? fieldConfig.lookup.table
                        : null;

                var searchBar =
                    item.options && item.options.searchBar !== undefined
                        ? item.options.searchBar
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchBar
                        ? editorConfig.lookup.searchBar
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchBar
                        ? fieldConfig.lookup.searchBar
                        : null;

                var columns =
                    item.options && item.options.columns
                        ? item.options.columns
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.columns
                        ? editorConfig.lookup.columns
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.columns
                        ? fieldConfig.lookup.columns
                        : undefined;

                var height =
                    item.options && item.options.height !== undefined
                        ? item.options.height
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                        ? editorConfig.lookup.height
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                        ? fieldConfig.lookup.height
                        : null;

                if (!height) {
                    if (String(item.dataField).endsWith('code')) height = 300;
                    else height = 250;
                }

                var width =
                    item.options && item.options.width !== undefined
                        ? item.options.width
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                        ? editorConfig.lookup.width
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                        ? fieldConfig.lookup.width
                        : null;

                var actionItems =
                    item.options && item.options.actionItems instanceof Array
                        ? item.options.actionItems
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.actionItems instanceof Array
                        ? editorConfig.lookup.actionItems
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.actionItems instanceof Array
                        ? fieldConfig.lookup.actionItems
                        : undefined;

                var mappings =
                    item.options && item.options.mapping instanceof Array
                        ? item.options.mapping
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mapping instanceof Array
                        ? editorConfig.lookup.mapping
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mapping instanceof Array
                        ? fieldConfig.lookup.mapping
                        : [];

                var mappingWhen =
                    item.options && item.options.mappingWhen instanceof Array
                        ? item.options.mappingWhen
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhen instanceof Array
                        ? editorConfig.lookup.mappingWhen
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhen instanceof Array
                        ? fieldConfig.lookup.mappingWhen
                        : null;

                var mappingWhenType =
                    item.options && item.options.mappingWhenType instanceof Array
                        ? item.options.mappingWhenType
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhenType instanceof Array
                        ? editorConfig.lookup.mappingWhenType
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhenType instanceof Array
                        ? fieldConfig.lookup.mappingWhenType
                        : null;

                var refreshOnOpened =
                    item.options && item.options.refreshOnOpened !== undefined
                        ? item.options.refreshOnOpened
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                        ? editorConfig.lookup.refreshOnOpened
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                        ? fieldConfig.lookup.refreshOnOpened
                        : undefined;

                var searchConditions =
                    item.options && item.options.searchConditions !== undefined
                        ? item.options.searchConditions
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                        ? editorConfig.lookup.searchConditions
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                        ? fieldConfig.lookup.searchConditions
                        : null;

                var lookupClientValues =
                    item.options && item.options.values !== undefined
                        ? item.options.values
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                        ? editorConfig.lookup.values
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                        ? fieldConfig.lookup.values
                        : null;

                lookupClientValues =
                    lookupClientValues instanceof Array && lookupClientValues.length > 0
                        ? lookupClientValues.map((o) => {
                              if (typeof o === 'string') return { code: o };
                              return o;
                          })
                        : typeof lookupClientValues === 'object' && lookupClientValues !== null
                        ? [lookupClientValues]
                        : typeof lookupClientValues === 'string' && lookupClientValues !== null
                        ? [{ code: lookupClientValues }]
                        : [];

                lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

                if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                    if (item.options && item.options.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = item.options.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                    if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                        lookupClientValues = lookupClientValues.map((o) => {
                            let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                            if (found) return { ...found, ...o };
                            else return o;
                        });
                    }
                }
                var lookupServerName =
                    item.options && item.options.lookupServerName !== undefined
                        ? item.options.lookupServerName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                        ? editorConfig.lookup.serverName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                        ? fieldConfig.lookup.serverName
                        : item.dataField;

                var lookupClientName =
                    item.options && item.options.lookupClientName !== undefined
                        ? item.options.lookupClientName
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                        ? editorConfig.lookup.clientName
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                        ? fieldConfig.lookup.clientName
                        : item.dataField;

                var isRemote =
                    item.options && item.options.isRemote !== undefined
                        ? item.options.isRemote
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                        ? editorConfig.lookup.isRemote
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                        ? fieldConfig.lookup.isRemote
                        : Boolean(url);

                if (!isRemote) {
                    if (lookupClientValues) dataSource = lookupClientValues;

                    if (prepareLookups instanceof Array && lookupServerName) {
                        var found = prepareLookups.find((l) => l.name === lookupServerName);

                        if (found && found.values instanceof Array) {
                            found = JSON.parse(stringify(found));
                            for (let i = 0; i < found.values.length; i++) {
                                var newValue = found.values[i];
                                if (newValue.code) {
                                    var oldValue = dataSource.find((d) => d.code === newValue.code);
                                    if (oldValue) {
                                        Object.keys(newValue).forEach((k) => {
                                            if (oldValue[k] === undefined) oldValue[k] = newValue[k];
                                        });
                                    } else dataSource.push(newValue);
                                } else dataSource.push(newValue);
                            }
                        }
                    }
                    if (searchConditions)
                        dataSource = dataSource.filter((value) =>
                            AntCondition.isValid(value, {
                                when: { ...searchConditions }
                            })
                        );

                    searchBar = false;
                    if (!columns)
                        columns = [
                            {
                                dataField: 'name'
                            }
                        ];
                } else {
                    if (!columns)
                        columns = [
                            {
                                dataField: item.dataField
                            }
                        ];
                }

                var isRequired = false;
                if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

                var allowNew =
                    item.options && item.options.allowNew !== undefined
                        ? item.options.allowNew
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                        ? editorConfig.lookup.allowNew
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                        ? fieldConfig.lookup.allowNew
                        : false;

                var showClearButton =
                    !item.disabled &&
                    (item.options && item.options.showClearButton !== undefined
                        ? item.options.showClearButton
                        : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                        ? editorConfig.lookup.showClearButton
                        : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                        ? fieldConfig.lookup.showClearButton
                        : !isRequired);

                var showDropDownButton = showClearButton
                    ? false
                    : !item.disabled &&
                      (item.options && item.options.showDropDownButton !== undefined
                          ? item.options.showDropDownButton
                          : editorConfig && editorConfig.lookup && editorConfig.lookup.showDropDownButton !== undefined
                          ? editorConfig.lookup.showDropDownButton
                          : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showDropDownButton !== undefined
                          ? fieldConfig.lookup.showDropDownButton
                          : true);
                return (
                    <AntDropDownTree
                        ref={itemRef}
                        formRef={form}
                        dataField={item.dataField}
                        name={tableName + '_' + item.name}
                        formDisplayField={formDisplayField}
                        API={props.API}
                        url={url}
                        isRemote={isRemote}
                        remotePaging={remotePaging}
                        refreshOnOpened={refreshOnOpened}
                        lookupName={lookupServerName}
                        searchConditions={searchConditions}
                        value={formData ? formData[item.dataField] : null}
                        acceptCustomValue={allowNew}
                        isSearching={item.options && item.options.isSearching !== undefined ? item.options.isSearching : true}
                        showClearButton={showClearButton}
                        showDropDownButton={showDropDownButton}
                        editorOptions={{
                            stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                            className: item.options && item.options.className ? item.options.className : undefined
                        }}
                        height={height}
                        width={width}
                        treeOptions={{
                            ...item.options,
                            module: moduleName,
                            table: tableName,
                            dataSource: dataSource,
                            keyExpr: keyField,
                            valueExpr: valueField,
                            displayExpr: displayField,
                            parentIdExpr: parentField,
                            columns: columns,
                            searchBar: searchBar,
                            actionItems: actionItems,
                            noDataText: AntLocalization.translateText({ vi: 'Không có dữ liệu !', en: 'Have no data !', fr: 'Aucune donnée !', es: '¡Sin datos!', id: 'Tidak ada data!', ja: 'データがありません！', zh: '没有数据！', ko: '데이터 없음!', hi: 'कोई डेटा नहीं!', ar: 'لا توجد بيانات!' })
                        }}
                        focusStateEnabled={!Boolean(item.disabled)}
                        validationRules={item.disabled ? [] : item.validationRules}
                        getQueryFields={() => {
                            return mappings.map((m) => m.from);
                        }}
                        onValueChanged={(e) => {
                            var obj = { [item.dataField]: e.value };
                            if (formDisplayField && displayField && formDisplayField !== item.dataField) {
                                obj[formDisplayField] = e.value !== null && e.value !== undefined && e.rowData ? e.rowData[displayField] : null;
                            }

                            var isMapping = true;
                            if (mappingWhen && typeof mappingWhen === 'object') {
                                isMapping = AntCondition.isValid(formData, {
                                    when: mappingWhen,
                                    whenType: mappingWhenType
                                });
                            }

                            if (isMapping) {
                                for (let i = 0; i < mappings.length; i++) {
                                    const m = mappings[i];

                                    if (m.when && typeof m.when === 'object') {
                                        var mValid = AntCondition.isValid(formData, {
                                            when: m.when,
                                            whenType: m.whenType
                                        });
                                        if (!mValid) continue;
                                    }

                                    var sourceField = m.from;
                                    var destField = m.to;
                                    if (sourceField && destField) {
                                        if (
                                            e.rowData === null ||
                                            e.rowData === undefined ||
                                            e.rowData[sourceField] === null ||
                                            e.rowData[sourceField] === undefined
                                        ) {
                                            if (formData[destField] !== null && formData[destField] !== undefined) obj[destField] = null;
                                        } else {
                                            if (formData[destField] !== e.rowData[sourceField]) obj[destField] = e.rowData[sourceField];
                                        }
                                    }

                                    var setField = m.set;
                                    var fieldValue = m.value;
                                    if (setField && fieldValue !== undefined) {
                                        obj[setField] = fieldValue;
                                    }
                                }
                            }
                            var keys = Object.keys(obj);
                            for (let i = 0; i < keys.length; i++) {
                                const k = keys[i];
                                args.component.itemOption(k, 'value', obj[k]);
                            }

                            if (keys.length > 0) onFieldDataChanged(obj);
                        }}
                        onFocusIn={(e) => {
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    />
                );
            }

            if (item.editorType == 'antRichEditor') {
                var rePh = item.placeholder || (fieldConfig && fieldConfig.placeholder);
                var reHeight = (item.options && item.options.height) || 260;
                var reToolbar = (item.options && item.options.toolbar) || 'standard';
                return (
                    <AntRichEditor
                        value={formData ? formData[item.dataField] : null}
                        onChange={(html) => {
                            onFieldDataChanged({ [item.dataField]: html });
                        }}
                        toolbar={reToolbar}
                        placeholder={rePh}
                        readOnly={!!item.disabled}
                        height={reHeight}
                    />
                );
            }

            if (item.editorType == 'antAttachmentList') {
                var aalOpts = item.options || {};
                var aalVoucherType = aalOpts.voucherType || (props.API && (props.API.tableName || props.API.entityName)) || tableName;
                var aalCode = formData ? (formData.code || formData[aalOpts.codeField || 'code']) : null;
                var aalId = formData ? (formData.id || formData[aalOpts.idField || 'id']) : null;
                return (
                    <AntAttachmentList
                        voucherType={aalVoucherType}
                        voucherCode={aalCode}
                        voucherId={aalId}
                        voucherModule={aalOpts.module}
                        readOnly={!!item.disabled || !!aalOpts.readOnly}
                        height={aalOpts.height}
                    />
                );
            }

            if (item.dataType === 'float' || item.dataType === 'decimal') {
                var decDigit = item.decimalDigit !== undefined && item.decimalDigit !== null ? item.decimalDigit : 2;
                var strFormat = decDigit > 0 ? '#,##0.' + String('#').repeat(decDigit) : '#,##0';
                if (item.unitType === 'Km') strFormat = strFormat + ' Km';

                if (item.showStepper) {
                    return (
                        <AntStepperBox
                            ref={itemRef}
                            {...item.options}
                            name={tableName + '_' + item.name}
                            focusStateEnabled={!Boolean(item.disabled)}
                            alignment={'center'}
                            format={strFormat}
                            defaultValue={formData ? formData[item.dataField] : null}
                            onValueChanged={(e) => {
                                onFieldDataChanged({
                                    [item.dataField]: e.value
                                });
                            }}
                            onFocusIn={(e) => {
                                let inputEl = e.element.querySelector('.dx-texteditor-input');
                                if (inputEl) {
                                    inputEl.selectionStart = 0;
                                    inputEl.selectionEnd = inputEl.value.length;
                                }
                                if (props.onFocusItem)
                                    props.onFocusItem({
                                        dataField: item.dataField
                                    });
                            }}
                        >
                            <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                        </AntStepperBox>
                    );
                }

                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        alignment={'right'}
                        format={strFormat}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (item.dataType == 'date') {
                var strFormat = item.format;
                if (!strFormat) {
                    strFormat = function (value) {
                        if (!value) return '';

                        // var unixValue = AntTime.fromDate(value).unix();
                        var unixValue = AntTime.init(value).unix();

                        if (AntTime.isUnixWithinToDay(unixValue))
                            return AntLocalization.translateText({ vi: 'Hôm nay', en: 'Today', fr: 'Aujourd\'hui', es: 'Hoy', id: 'Hari ini', ja: '今日', zh: '今天', ko: '오늘', hi: 'आज', ar: 'اليوم' });

                        if (AntTime.isUnixWithinYesterday(unixValue))
                            return AntLocalization.translateText({ vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीता)', ar: 'أمس' });

                        if (AntTime.isUnixWithinTomorrow(unixValue))
                            return AntLocalization.translateText({ vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल (आने वाला)', ar: 'غداً' });

                        if (AntTime.isUnixWithinCurrentYear(unixValue)) return AntTime.fromUnix(unixValue).format('DD/MM');

                        return AntTime.fromUnix(unixValue).format('DD/MM/YYYY');
                    };
                }
                return (
                    <DateBox
                        ref={itemRef}
                        showClearButton={true}
                        showAnalogClock={false}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        alignment={'right'}
                        defaultValue={formData && formData[item.dataField] ? AntTime.init(formData[item.dataField]).toDate() : null}
                        type={'date'}
                        displayFormat={strFormat}
                        onValueChanged={(e) => {
                            var value = e.value ? AntTime.startOfDay(e.value).unix() : null;

                            onFieldDataChanged({
                                [item.dataField]: value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </DateBox>
                );
            }

            if (item.dataType == 'datetime') {
                var strFormat = item.format;
                if (!strFormat) {
                    strFormat = function (value) {
                        if (!value) return '';

                        // var unixValue = AntTime.fromDate(value).unix();
                        var unixValue = AntTime.init(value).unix();

                        if (AntTime.isUnixWithinToDay(unixValue)) return AntTime.fromUnix(unixValue).format('hh:mm A');

                        // if (AntTime.isUnixWithinYesterday(unixValue)) return 'Hôm qua ' + AntTime.fromUnix(unixValue).format('HH:mm');
                        if (AntTime.isUnixWithinYesterday(unixValue))
                            return AntLocalization.translateText({ vi: 'Hôm qua', en: 'Yesterday', fr: 'Hier', es: 'Ayer', id: 'Kemarin', ja: '昨日', zh: '昨天', ko: '어제', hi: 'कल (बीता)', ar: 'أمس' });

                        if (AntTime.isUnixWithinTomorrow(unixValue))
                            return AntLocalization.translateText({ vi: 'Ngày mai', en: 'Tomorrow', fr: 'Demain', es: 'Mañana', id: 'Besok', ja: '明日', zh: '明天', ko: '내일', hi: 'कल (आने वाला)', ar: 'غداً' });

                        if (AntTime.isUnixWithinCurrentYear(unixValue)) return AntTime.fromUnix(unixValue).format('DD/MM HH:mm');

                        return AntTime.fromUnix(unixValue).format('DD/MM/YYYY');
                    };
                }
                return (
                    <DateBox
                        ref={itemRef}
                        showClearButton={true}
                        showAnalogClock={false}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        alignment={'right'}
                        defaultValue={formData && formData[item.dataField] ? AntTime.init(formData[item.dataField]).toDate() : null}
                        type={'datetime'}
                        displayFormat={strFormat}
                        onValueChanged={(e) => {
                            var value = e.value ? AntTime.unix(e.value) : null;

                            onFieldDataChanged({
                                [item.dataField]: value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </DateBox>
                );
            }

            if (item.dataType == 'time') {
                return (
                    <DateBox
                        ref={itemRef}
                        showClearButton={true}
                        showAnalogClock={false}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        alignment={'right'}
                        defaultValue={formData && formData[item.dataField] ? AntTime.init(formData[item.dataField]).toDate() : null}
                        type={'time'}
                        displayFormat={item.format ? item.format : 'hh:mm a'}
                        onValueChanged={(e) => {
                            var value = e.value ? AntTime.timeUnix(AntTime.unix(e.value)) : null;

                            onFieldDataChanged({
                                [item.dataField]: value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </DateBox>
                );
            }

            if (
                item.dataType === 'hour' ||
                item.dataType === 'hours' ||
                (item.dataType == 'int' && (item.dataTypeDisplay === 'hours' || item.fieldConfig?.dataTypeDisplay === 'hours'))
            ) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={`#,##0 ${AntLocalization.translateText({ vi: 'giờ', en: 'hours', fr: 'heures', es: 'horas', id: 'jam', ja: '時間', zh: '小时', ko: '시간', hi: 'घंटे', ar: 'ساعات' })}`}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (
                item.dataType === 'minute' ||
                item.dataType === 'minutes' ||
                (item.dataType == 'int' && (item.dataTypeDisplay === 'minutes' || item.fieldConfig?.dataTypeDisplay === 'minutes'))
            ) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={`#,##0 ${AntLocalization.translateText({ vi: 'phút', en: 'minutes', fr: 'minutes', es: 'minutos', id: 'menit', ja: '分', zh: '分钟', ko: '분', hi: 'मिनट', ar: 'دقائق' })}`}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (item.dataType === 'gram' || (item.dataType == 'int' && item.dataTypeDisplay === 'gram')) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={'#,##0 gram'}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (
                item.dataType === 'day' ||
                item.dataType === 'days' ||
                (item.dataType == 'int' && (item.dataTypeDisplay === 'days' || item.fieldConfig?.dataTypeDisplay === 'days'))
            ) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={`#,##0 ${AntLocalization.translateText({ vi: 'ngày', en: 'days', fr: 'jours', es: 'días', id: 'hari', ja: '日', zh: '天', ko: '일', hi: 'दिन', ar: 'أيام' })}`}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }
            if (
                item.dataType === 'week' ||
                item.dataType === 'weeks' ||
                (item.dataType == 'int' && (item.dataTypeDisplay === 'weeks' || item.fieldConfig?.dataTypeDisplay === 'weeks'))
            ) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={`#,##0 ${AntLocalization.translateText({ vi: 'tuần', en: 'weeks', fr: 'semaines', es: 'semanas', id: 'minggu', ja: '週間', zh: '周', ko: '주', hi: 'सप्ताह', ar: 'أسابيع' })}`}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (
                item.dataType === 'months' ||
                (item.dataType == 'int' && (item.dataTypeDisplay === 'months' || item.fieldConfig?.dataTypeDisplay === 'months'))
            ) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={`#,##0 ${AntLocalization.translateText({ vi: 'tháng', en: 'months', fr: 'mois', es: 'meses', id: 'bulan', ja: 'ヶ月', zh: '个月', ko: '개월', hi: 'महीने', ar: 'أشهر' })}`}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (
                item.dataType === 'year' ||
                item.dataType === 'years' ||
                (item.dataType == 'int' && (item.dataTypeDisplay === 'years' || item.fieldConfig?.dataTypeDisplay === 'years'))
            ) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={`#,##0 ${AntLocalization.translateText({ vi: 'năm', en: 'years', fr: 'années', es: 'años', id: 'tahun', ja: '年間', zh: '年', ko: '년', hi: 'वर्ष', ar: 'سنوات' })}`}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (item.dataType === 'period' || (item.dataType == 'int' && item.dataTypeDisplay === 'period')) {
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={`#,##0 ${AntLocalization.translateText({ vi: 'kỳ', en: 'periods', fr: 'périodes', es: 'períodos', id: 'periode', ja: '期間', zh: '期', ko: '기간', hi: 'अवधि', ar: 'فترات' })}`}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (item.dataType === 'int' || item.dataType === 'fixedPoint')
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        format={{ type: 'fixedPoint' }}
                        alignment={'right'}
                        defaultValue={formData ? parseInt(formData[item.dataField]) : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );

            if (item.dataType === 'percent')
                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        alignment={'right'}
                        // format={{ type: 'percent', precision: item.decimalDigit }}
                        format={{
                            type: 'percent',
                            precision: item.decimalDigit !== undefined ? item.decimalDigit : 0
                        }}
                        defaultValue={formData ? parseFloat(formData[item.dataField]) : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );

            if (item.dataType === 'currency') {
                // Resolve currency theo chain: keepBaseCurrency → spec.currency → spec.currencyField
                //   → form-level props.currencyField → Sys_BaseCurrency.
                // formData = data của form hiện tại; props.parentData = data của voucher cha (nếu form là child).
                var currencySpec = item?.options?.currency || {};
                var resolvedCurrency = AntLocalization.resolveCurrency(currencySpec, formData, props.parentData, props.currencyField);

                if (Boolean(item.disabled))
                    return (
                        <TextBox
                            ref={itemRef}
                            {...item.options}
                            name={tableName + '_' + item.name}
                            focusStateEnabled={false}
                            defaultValue={formData ? AntLocalization.translateCurrency(formData[item.dataField], false, { currency: resolvedCurrency }) : null}
                            alignment={'right'}
                        ></TextBox>
                    );

                let strFormat = AntLocalization.getCurrencyFormat({
                    currency: resolvedCurrency,
                    isPrefix: currencySpec.isPrefix,
                    currencyDisplay: currencySpec.currencyDisplay
                });

                return (
                    <NumberBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        // format={AntLocalization.formatCurrency(
                        //     item.showSign !== undefined
                        //         ? item.showSign
                        //         : fieldConfig && fieldConfig.showSign !== undefined
                        //         ? fieldConfig.showSign
                        //         : false
                        // )}
                        format={strFormat}
                        // format={
                        //     Boolean(item.disabled)
                        //         ? AntLocalization.getCurrencyFormat()
                        //         : AntLocalization.formatCurrency(
                        //               item.showSign !== undefined
                        //                   ? item.showSign
                        //                   : fieldConfig && fieldConfig.showSign !== undefined
                        //                   ? fieldConfig.showSign
                        //                   : false
                        //           )
                        // }
                        alignment={'right'}
                        defaultValue={formData ? parseFloat(formData[item.dataField]) : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </NumberBox>
                );
            }

            if (item.dataType === 'phone') {
                var _pm = getPhoneMask();
                return (
                    <TextBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        showMaskMode="onFocus"
                        mask={_pm.mask}
                        maskRules={_pm.rules}
                        alignment={'right'}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </TextBox>
                );
            }

            if (item.dataType === 'email')
                return (
                    <TextBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        mode="email"
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        // onFocusIn={(e) => {
                        //     let inputEl = e.element.querySelector('.dx-texteditor-input');
                        // if (inputEl) {
                        //     inputEl.selectionStart = 0;
                        //     inputEl.selectionEnd = inputEl.value.length;
                        // }
                        // if (props.onFocusItem)
                        // props.onFocusItem({
                        //     dataField: item.dataField
                        // });
                        // }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </TextBox>
                );

            if (item.editorType === 'antFormLink') {
                return (
                    <TextBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        defaultValue={formData ? formData[item.dataField] : null}
                        readOnly={true}
                        disabled={false}
                        hoverStateEnabled={false}
                        focusStateEnabled={false}
                        activeStateEnabled={false}
                    >
                        <TextBoxButton
                            name={'btnLink'}
                            location={'after'}
                            options={{
                                // icon:'export',
                                elementAttr: { class: 'ant-link-in-form' },
                                icon: "<svg stroke='currentColor' fill='none' stroke-width='2' viewBox='0 0 24 24' stroke-linecap='round' stroke-linejoin='round' class='dx-icon' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg'><path stroke='none' d='M0 0h24v24H0z' fill='none'></path><path d='M12 16l4 -4l-4 -4'></path><path d='M8 12h8'></path><path d='M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z'></path></svg>",
                                type: 'normal',
                                stylingMode: 'text',
                                hoverStateEnabled: false,
                                focusStateEnabled: false,
                                activeStateEnabled: false,
                                disabled: false,
                                onClick: (e) => {
                                    if (item.linkUrl && formData && formData[item.dataField]) {
                                        var ar = [];
                                        if (item.linkUrl instanceof Array) {
                                            for (let i = 0; i < item.linkUrl.length; i++) {
                                                ar.push(item.linkUrl[i]);
                                            }
                                        } else if (typeof item.linkUrl === 'object')
                                            ar.push({
                                                when: item.linkUrl.when,
                                                url: item.linkUrl.url,
                                                key: item.linkUrl.key
                                            });
                                        else
                                            ar.push({
                                                url: String(item.linkUrl)
                                            });

                                        for (let i = 0; i < ar.length; i++) {
                                            const ele = ar[i];

                                            var when = ele.when ? ele.when : null;
                                            if (when && typeof when === 'object') {
                                                var isValid = true;

                                                var keys = Object.keys(when);
                                                for (let j = 0; j < keys.length; j++) {
                                                    const k = keys[j];
                                                    if (formData[k] !== undefined && formData[k] !== when[k]) isValid = false;
                                                }

                                                if (!isValid) continue;
                                            }

                                            var url = ele.url ? ele.url : null;
                                            var key = ele.key ? ele.key : item.dataField;

                                            if (url) {
                                                var link = String(url);
                                                if (!link.startsWith('/')) link = '/' + link;
                                                if (!link.endsWith('/')) link = link + '/';
                                                link = format('{0}{2}', link, null, formData[key]);
                                                navigate(link);
                                            }
                                        }
                                    }
                                }
                            }}
                        />
                    </TextBox>
                );
            }

            if (item.dataType !== 'empty' && (item.editorType === 'dxTextBox' || item.editorType === undefined)) {
                var mode = 'text';
                if (item.dataType == 'password') mode = 'password';
                return (
                    <TextBox
                        ref={itemRef}
                        {...item.options}
                        name={tableName + '_' + item.name}
                        focusStateEnabled={!Boolean(item.disabled)}
                        mode={mode}
                        defaultValue={formData ? formData[item.dataField] : null}
                        onValueChanged={(e) => {
                            onFieldDataChanged({
                                [item.dataField]: e.value
                            });
                        }}
                        onFocusIn={(e) => {
                            let inputEl = e.element.querySelector('.dx-texteditor-input');
                            if (inputEl) {
                                inputEl.selectionStart = 0;
                                inputEl.selectionEnd = inputEl.value.length;
                            }
                            if (props.onFocusItem)
                                props.onFocusItem({
                                    dataField: item.dataField
                                });
                        }}
                    >
                        <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                    </TextBox>
                );
            }
        },
        [formItems, formData, initFormItem, tableName, onFieldDataChanged, props.onFocusItem, props.labelLocation, props.allCheckBoxLeft, props.API]
    );

    const loadByObj = useCallback(
        (inputObj) => {
            if (!inputObj) return {};

            let defaultObj = inputObj ? JSON.parse(stringify(inputObj)) : {};

            var obj = initDefaultValues();

            if (obj)
                Object.keys(obj).forEach(function (key) {
                    if (defaultObj[key] === undefined) defaultObj[key] = obj[key];
                });

            if (props.default)
                Object.keys(props.default).forEach(function (key) {
                    defaultObj[key] = props.default[key];
                });

            Object.keys(defaultObj).map((k) => {
                if (defaultObj[k] !== null && typeof defaultObj[k] === 'object') defaultObj[k] = AntCondition.getValueFromSession(defaultObj[k]);
            });

            if (rawFlatItems instanceof Array) {
                rawFlatItems.forEach((item) => {
                    if (item.dataField) {
                        var value;
                        if (item.formula instanceof Array) {
                            var fm = item.formula[0];
                            var defaultNullValue =
                                item.formula[1] !== undefined && item.formula[1] !== null && typeof item.formula[1] === 'number'
                                    ? item.formula[1]
                                    : 0;
                            value = Calculator.execNum(defaultObj, fm, defaultNullValue);
                            defaultObj[item.dataField] = value;
                        } else if (item.dataType === 'join') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!defaultObj) return null;

                                        if (!item.byPassInnerFieldVisible) {
                                            let visible = isVisibleField({ dataField: f });
                                            if (!visible) return null;
                                        }

                                        return defaultObj[f];
                                    })

                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .join(item.separator ? item.separator : ', ');
                            }
                            defaultObj[item.dataField] = value;
                        } else if (item.dataType === 'first') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!defaultObj) return null;

                                        if (!item.byPassInnerFieldVisible) {
                                            let visible = isVisibleField({ dataField: f });
                                            if (!visible) return null;
                                        }

                                        return defaultObj[f];
                                    })
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .shift();
                            }
                            defaultObj[item.dataField] = value;
                        } else if (item.dataType === 'last') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!defaultObj) return null;

                                        if (!item.byPassInnerFieldVisible) {
                                            let visible = isVisibleField({ dataField: f });
                                            if (!visible) return null;
                                        }

                                        return defaultObj[f];
                                    })
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .pop();
                            }
                            defaultObj[item.dataField] = value;
                        }
                    }
                });
            }

            if (!formLookups.current || formLookups.current instanceof Array === false || formLookups.current.length <= 0)
                formLookups.current = inputObj && inputObj.lookups instanceof Array ? JSON.parse(stringify(inputObj.lookups)) : [];

            inputObj = Object.assign(inputObj, defaultObj);
            // delete inputObj.lookups;

            setFormData(inputObj);
        },
        [initDefaultValues, rawFlatItems, props.default, isVisibleField]
    );

    const onContentReady = useCallback(
        (e) => {
            if (props.onContentReady) props.onContentReady();
            resetUI();
        },
        [resetUI, props.onContentReady]
    );

    const formDisplayItems = useMemo(() => initFormDisplayItems(props.items), [formItems, formData, shouldRender, props.shouldRender]);

    // Khi hideFormFields=true nhưng caller muốn giữ lại 1 vài field (vd: code, created_at,
    // released_at trên AROrder/APOrder sau khi Release), truyền `keepFormFields` là Array
    // tên field. Form vẫn render, nhưng chỉ giữ những item match — group rỗng bị loại bỏ.
    const filteredDisplayItems = useMemo(() => {
        if (!props.hideFormFields) return formDisplayItems;
        const keep = props.keepFormFields;
        if (!Array.isArray(keep) || keep.length === 0) return formDisplayItems;
        const keepSet = new Set(keep);
        const walk = (items) => {
            const out = [];
            items.forEach((it) => {
                if (it.itemType === 'group' && Array.isArray(it.items)) {
                    const sub = walk(it.items);
                    if (sub.length > 0) out.push({ ...it, items: sub });
                } else if (it.itemType === 'empty') {
                    // skip empty spacers khi đang filter
                } else if (keepSet.has(it.name) || keepSet.has(it.dataField)) {
                    out.push(it);
                }
            });
            return out;
        };
        return walk(formDisplayItems);
    }, [formDisplayItems, props.hideFormFields, props.keepFormFields]);

    const hideEntireForm =
        props.hideFormFields && (!Array.isArray(props.keepFormFields) || props.keepFormFields.length === 0);

    useEffect(() => {
        resetUI();
    }, [shouldRender]);

    useEffect(() => {
        resetUI();
    }, [props.shouldRender]);

    useImperativeHandle(ref, () => ({
        validate: validate,
        getDataForUpdate: getDataForUpdate,
        onAction: onAction,
        isHadNewData: isHadNewData,
        forceRender: forceRender,
        refreshData: (changes) => {
            if (!changes || Object.keys(changes).length === 0) return;
            setFormData((v) => Object.assign(v, changes));
            forceRender();
        }
    }));

    useEffect(() => {
        if (props.formData) loadByObj(props.formData);
    }, [props.formData]);

    // Effect 1: rebuild items khi props.items (= rawFlatItems) thay đổi — luôn chạy
    // để initial mount và caller-driven items reload (vd: setRawSettings sau batch)
    // đều render đúng danh sách.
    useEffect(() => {
        setFormItems(initFormItems());
    }, [rawFlatItems]);

    // Effect 2: re-eval visibility/disable khi formData internal thay đổi (mỗi click
    // checkbox / keystroke). Bỏ qua khi caller (vd: AntSettingForm) bật
    // bypassReevalOnFormDataChange — settings phần lớn là toggle độc lập, re-eval
    // mỗi click chỉ gây remount DevExtreme Form → reset scroll/focus.
    useEffect(() => {
        if (props.bypassReevalOnFormDataChange) return;
        setFormItems(initFormItems());
    }, [formData, initFormItems]);

    // useEffect(() => {
    //     console.log('ant-EditForm-change-prepared : ');
    //     if (prepared) formItems = initFormItems();
    // }, [prepared]);

    return (
        <React.Fragment>
            {shouldRender && !hideEntireForm && (
                <ValidationGroup ref={validateGroup}>
                    <p />
                    <Form
                        className="ant-form ant-edit-form"
                        ref={form}
                        shouldRender={shouldRender + (props.shouldRender ? props.shouldRender : 1)}
                        labelLocation={props.labelLocation ? props.labelLocation : 'left'}
                        alignItemLabelsInAllGroups={props.alignItemLabelsInAllGroups !== undefined ? props.alignItemLabelsInAllGroups : true}
                        formData={formData}
                        colCount={formColCount}
                        visible={props.visible !== undefined ? props.visible : true}
                        items={filteredDisplayItems}
                        onContentReady={onContentReady}
                    >
                        <Template name={'renderItem'} render={renderItem} />
                        <Template name={'renderGroupCaption'} render={renderGroupCaption} />
                        {/* <Template name={'renderCollapsibleGroup'} render={renderCollapsibleGroup} /> */}
                    </Form>
                </ValidationGroup>
            )}
            {/* Optional custom slot at the bottom of the form (after the DevExtreme Form).
                Caller passes either a JSX node or a function (formData, onFieldDataChanged) => JSX.
                onFieldDataChanged forwards trực tiếp lên parent (AntVoucher) — bypass DevExtreme
                Form, dùng khi custom UI tự render control (KHÔNG qua AntBaseForm fields).
                Khi không truyền: render giống hệt như cũ (zero impact). */}
            {props.renderFooter && (typeof props.renderFooter === 'function' ? props.renderFooter(formData, props.onFieldDataChanged) : props.renderFooter)}
        </React.Fragment>
    );
});
